<div *ngIf="section != 'UserDetails'">
  <!-- <div class="row sticky-top-button">
    <div class="row d-flex justify-content-start align-items-center mt-2 mb-2">
      <button type="button" class="btn btn-circle btn-secondary" title="Click to go back" *ngIf="(
      ((!isMainScreen && !isRegistration && !issignin) ||
      isBookingQuetionary ||
      isBookingHistory ||
      isPaymentHistory ||
      isregister ||
      isbooknow) &&
      !isFinalPayment) ||
      IsUserDetailsType == 'click' ||
      (BookingHistory.length > 0 && IsPatientHistorySheet)" (click)="GetBack()">
        <i class="fa fa-lg fa-arrow-left" aria-hidden="true"></i> Back
      </button>
    </div>

  </div> -->

  <!--Login-->
  <div *ngIf="section == 'booking-login-register'">
    <div class="container1 d-flex justify-content-center align-items-center"
      *ngIf="isMainScreen && !globals.IsUserDetailsUpdate">
      <div class="login-card shadow-lg p-4">
        <div class="d-flex justify-content-center mb-1">
          <img class="newLogo" src="/assets/img/New Logo - Transperent.png" width="80" height="80" alt="" />
        </div>
        <h3 class="text-center responsive-text mb-2" style="color: #026d64">
          Welcome to Nisargopchar Ashram
        </h3>
        <!-- Sign Up -->
        <!-- <div class="text-center" *ngIf="OnlineUserRegistration.LoginMethod == 'password'" style="font-family: Calibri">
        Not yet registered?
        <a (click)="GetRegistartion()" class="text-primary font-weight-bold">Sign Up</a>
      </div> -->
        <h5 class="text-center text-dark fontsizeandfamilyCalibri">
          Sign into your account
        </h5>

        <!-- Login Options (Pwd/OTP) -->
        <!-- <div class="login-options text-center mt-1">
        <label class="option fontsizeandfamilyCalibri">
          <input type="radio" name="LoginMethod" [(ngModel)]="OnlineUserRegistration.LoginMethod" value="password"
            (click)="resetForm()" />
          Login with Password
        </label>
        <label class="option fontsizeandfamilyCalibri">
          <input type="radio" name="LoginMethod" [(ngModel)]="OnlineUserRegistration.LoginMethod" value="otp"
            (click)="resetForm()" />
          Login with OTP
        </label>
      </div> -->

        <div style="
        display: flex;
        justify-content: center;
        background: #eef4f0;
        border-radius: 8px;
        margin-bottom: 18px;
        overflow: hidden;
      ">
          <button type="button"
            (click)="OnlineUserRegistration.LoginMethod='password'; clearFieldError(''); resetForm('password')"
            [ngStyle]="{
          flex: '1',
          padding: '8px 0',
          border: 'none',
          cursor: 'pointer',
          background: OnlineUserRegistration.LoginMethod == 'password' ? '#0d9488' : 'transparent',
          color: OnlineUserRegistration.LoginMethod == 'password' ? '#fff' : '#333',
          fontWeight: '600',
          fontSize: '0.9rem'
        }">
            Password Login
          </button>

          <button type="button"
            (click)="OnlineUserRegistration.LoginMethod='otp'; clearFieldError(''); resetForm('otp')" [ngStyle]="{
          flex: '1',
          padding: '8px 0',
          border: 'none',
          cursor: 'pointer',
          background: OnlineUserRegistration.LoginMethod == 'otp' ? '#0d9488' : 'transparent',
          color: OnlineUserRegistration.LoginMethod == 'otp' ? '#fff' : '#333',
          fontWeight: '600',
          fontSize: '0.9rem'
        }">
            OTP Login
          </button>
        </div>

        <!-- Login Form -->
        <form [formGroup]="ngForm" class="mt-2">
          <div [ngClass]="OnlineUserRegistration.LoginMethod == 'otp' ? 'input-group' : 'form-group'">
            <!-- <label class="font-weight-bold">User Id / Email / Mobile</label> -->
            <input type="text" class="form-control" formControlName="UserName" id="LoginUserName"
              (input)="clearFieldError('LoginUserID');" [(ngModel)]="OnlineUserRegistration.UserName"
              placeholder="Enter Email / Mobile No." />

            <div class="input-group-append" *ngIf="OnlineUserRegistration.LoginMethod == 'otp'">
              <button type="button" class="btn btn-block btn-square btn-lg"
                style="background:'#0d9488';color:'#fff';line-height: 1;"
                *ngIf="OnlineUserRegistration.LoginMethod == 'otp' && !IsOTPSent"
                (click)="SendOTPForLoginWithOTP(OnlineUserRegistration.UserName)">
                <i [ngClass]="
                isInProgressOTP ? 'spinner-border spinner-border-sm mr-1' : ''
              "></i>
                {{ "Send OTP" | translate }}
              </button>
            </div>


            <div *ngIf="OnlineUserRegistration.LoginMethod == 'password'">
              <small *ngIf="
              ngForm.controls['UserName'].hasError('required') &&
              ngForm.controls['UserName'].touched
            " class="text-danger sizeless fontsizeandfamilyCalibri">
                You must include a Email/ MobileNo.
              </small>
              <small *ngIf="fieldErrors['LoginUserID']" class="text-danger">
                {{ fieldErrors['LoginUserID'] }}
              </small>
            </div>

            <!--User ID / Email / Mobile-->
          </div>
          <div class="d-flex justify-content-center align-items-center"
            *ngIf="OnlineUserRegistration.LoginMethod == 'otp'">
            <div [ngClass]="isInProgressOTP ? 'blink_me mt-2' : 'd-none'">
              <label>Sending OTP ...</label>
            </div>
            <label class="resend-text" *ngIf="IsOTPSent"> <!--Resend OTP-->
              Didn't receive the OTP?
              <button (click)="resendOtp('LoginWthOTP')" class="btn btn-link text-primary resend-link"
                [disabled]="isResendDisabled || isResendUsed">
                Resend OTP <span *ngIf="isResendDisabled">({{ countdown }})</span>
              </button>
            </label>
          </div>
          <div *ngIf="OnlineUserRegistration.LoginMethod == 'otp'">
            <small *ngIf="
              ngForm.controls['UserName'].hasError('required') &&
              ngForm.controls['UserName'].touched
            " class="text-danger sizeless fontsizeandfamilyCalibri">
              You must include a Email/ MobileNo.
            </small>
            <small *ngIf="fieldErrors['LoginUserID']" class="text-danger">
              {{ fieldErrors['LoginUserID'] }}
            </small>
          </div>

          <div class="form-group mt-1">
            <div class="input-group">
              <!--password-->
              <input [type]="hidePassword ? 'password' : 'text'" class="form-control" formControlName="LoginPassword"
                id="LoginPassOTP" (input)="clearFieldError('LoginPassOTP');"
                *ngIf="OnlineUserRegistration.LoginMethod == 'password'"
                [(ngModel)]="OnlineUserRegistration.LoginPassword" [placeholder]="
                OnlineUserRegistration.LoginMethod === 'password'
                  ? 'Enter Password'
                  : 'Enter OTP'
              " (keypress)="
                OnlineUserRegistration.LoginMethod === 'password'
                  ? null
                  : validateService.numberOnly($event)
              " [attr.maxlength]="
                OnlineUserRegistration.LoginMethod === 'password' ? null : 4
              " />
              <div class="input-group-append">
                <span class="input-group-text password-toggle" (click)="togglePassword()"
                  *ngIf="OnlineUserRegistration.LoginMethod == 'password'">
                  <i [ngClass]="hidePassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                </span>
              </div>
            </div>
            <div class="otp-inputs" *ngIf="OnlineUserRegistration.LoginMethod == 'otp'"> <!--OTP-->
              <input *ngFor="let digit of Loginotp; let i = index" type="text" maxlength="1" [value]="Loginotp[i]"
                (input)="onInput($event, i)" (keypress)="validateService.numberOnly($event)"
                (keydown)="onKeyDown($event, i)" #otpInput [disabled]="!IsOTPSent" />
            </div>
            <small *ngIf="
              ngForm.controls['LoginPassword'].hasError('required') &&
              ngForm.controls['LoginPassword'].touched &&
              (OnlineUserRegistration.LoginMethod == 'password' ||
                (OnlineUserRegistration.LoginMethod == 'otp' &&
                  IsOTPSent == true))
            " class="text-danger sizeless fontsizeandfamilyCalibri">
              You must include
              {{
              OnlineUserRegistration.LoginMethod === "password"
              ? "password"
              : "OTP"
              }}.
            </small>

            <small *ngIf="fieldErrors['LoginPassOTP']" class="text-danger">
              {{ fieldErrors['LoginPassOTP'] }}
            </small>
          </div>

          <!-- Forgot Password/Forgot UserID -->
          <div class="text-right d-flex justify-content-between" style="font-family: Calibri;font-size: 1em;"
            *ngIf="OnlineUserRegistration.LoginMethod == 'password'">
            <!--dipti-->
            <div>
              <a class="d-none" routerLink="/session/forgot-password" style="color: #0d9488;"
                [queryParams]="{ type: 'user ID' }">Forgot
                User
                ID</a>
            </div>
            <div>
              <a routerLink="/session/forgot-password" style="color: #0d9488;"
                [queryParams]="{ type: 'password' }">Forgot
                Password</a>
            </div>



          </div>

          <!-- SendOTP / Login  // Cancel Buttons -->
          <div class="mt-3">
            <!-- <button type="button" class="btn btn-block btn-square btn-lg" style="background:'#0d9488';color:'#fff'"
            *ngIf="OnlineUserRegistration.LoginMethod == 'otp' && !IsOTPSent"
            (click)="SendOTPForLoginWithOTP(OnlineUserRegistration.UserName)">
            <i [ngClass]="
                isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''
              "></i>
            {{ "Send OTP" | translate }}
          </button> -->
            <!-- *ngIf="
              OnlineUserRegistration.LoginMethod == 'password' ||
              (OnlineUserRegistration.LoginMethod == 'otp' && IsOTPSent == true)
            "  -->
            <button type="button" class="btn btn-block" style="background:'#0d9488';color:'#fff'"
              (click)="register('L'); GetsigninDetails('signin')">
              <i [ngClass]="
                isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''
              "></i>
              Login
            </button>
            <!-- <button type="button" class="btn btn-secondary btn-block" (click)="resetForm('password')">
            Cancel
          </button> -->
          </div>

          <div class="text-center mt-2" style="font-family: Calibri">
            If you are new user ?
            <a (click)="GetRegistartion()" class="text-primary font-weight-bold">Sign Up</a> here
          </div>
          <!-- Home -->
          <div class="text-center mt-2" style="font-family: Calibri">
            Return to
            <!-- routerLink="/session/home" -->
            <a (click)="goHome()" class="text-primary font-weight-bold">Home</a>
          </div>
        </form>
      </div>
    </div>

    <!-- <div *ngIf="isMainScreen && !globals.IsUserDetailsUpdate" style="
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: linear-gradient(180deg, #f9f9f6, #f0f4ec);
    font-family: 'Segoe UI', Calibri, sans-serif;
  ">
    <div style="
      width: 380px;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 14px;
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
      padding: 25px 25px 35px;
      text-align: center;
    ">
      <div style="display: flex; justify-content: center; margin-bottom: 10px;">
        <img src="/assets/img/New Logo - Transperent.png" alt="Logo" width="85" height="85"
          style="border-radius: 50%;" />
      </div>

      <h3 style="
        color: #064e3b;
        font-size: 1.35rem;
        font-weight: bold;
        margin-bottom: 4px;
      ">
        Welcome to Nisargopchar Ashram
      </h3>
      <p style="
        color: #64748b;
        font-size: 0.95rem;
        margin-bottom: 18px;
        font-style: italic;
      ">
        Holistic Healing through Nature
      </p>

      <div style="
        display: flex;
        justify-content: center;
        background: #eef4f0;
        border-radius: 8px;
        margin-bottom: 18px;
        overflow: hidden;
      ">
        <button type="button" (click)="OnlineUserRegistration.LoginMethod='password'; resetForm('password')" [ngStyle]="{
          flex: '1',
          padding: '8px 0',
          border: 'none',
          cursor: 'pointer',
          background: OnlineUserRegistration.LoginMethod === 'password' ? '#0d9488' : 'transparent',
          color: OnlineUserRegistration.LoginMethod === 'password' ? '#fff' : '#333',
          fontWeight: '600',
          fontSize: '0.9rem'
        }">
          Password Login
        </button>

        <button type="button" (click)="OnlineUserRegistration.LoginMethod='otp'; resetForm('password')" [ngStyle]="{
          flex: '1',
          padding: '8px 0',
          border: 'none',
          cursor: 'pointer',
          background: OnlineUserRegistration.LoginMethod === 'otp' ? '#0d9488' : 'transparent',
          color: OnlineUserRegistration.LoginMethod === 'otp' ? '#fff' : '#333',
          fontWeight: '600',
          fontSize: '0.9rem'
        }">
          OTP Login
        </button>
      </div>

      <form [formGroup]="ngForm" style="text-align: left;">
        <div style="margin-bottom: 12px;">
          <input type="text" formControlName="UserName" [(ngModel)]="OnlineUserRegistration.UserName"
            placeholder="Email / Mobile / User ID" style="
            width: 100%;
            padding: 10px 12px;
            border-radius: 6px;
            border: 1px solid #d1d5db;
            font-size: 0.95rem;
          " />
        </div>

        <div style="margin-bottom: 10px; position: relative;">
          <input [type]="hidePassword ? 'password' : 'text'" formControlName="LoginPassword"
            [(ngModel)]="OnlineUserRegistration.LoginPassword"
            [placeholder]="OnlineUserRegistration.LoginMethod === 'password' ? 'Password' : 'Enter OTP'" style="
            width: 100%;
            padding: 10px 12px;
            border-radius: 6px;
            border: 1px solid #d1d5db;
            font-size: 0.95rem;
          " />
          <span (click)="togglePassword()" style="
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            cursor: pointer;
            color: #6b7280;
          ">
            <i [ngClass]="hidePassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
          </span>
        </div>

        <div *ngIf="OnlineUserRegistration.LoginMethod == 'password'"
          style="text-align: right; font-size: 0.85rem; margin-bottom: 12px;">
          <a routerLink="/session/forgot-password" [queryParams]="{ type: 'password' }"
            style="color: #0284c7; text-decoration: none; margin-right: 5px;">Forgot password?</a>
          |
          <a routerLink="/session/forgot-password" [queryParams]="{ type: 'user ID' }"
            style="color: #0284c7; text-decoration: none; margin-left: 5px;">Forgot User ID?</a>
        </div>

        <button type="button" (click)="register('L'); GetsigninDetails('signin')" style="
          width: 100%;
          background: #0d9488;
          color: white;
          border: none;
          border-radius: 6px;
          padding: 10px;
          font-weight: 600;
          cursor: pointer;
          transition: background 0.3s;
        ">
          Login
        </button>

        <button type="button" (click)="resetForm('password')" style="
          width: 100%;
          background: #e5e7eb;
          color: #111827;
          border: none;
          border-radius: 6px;
          padding: 10px;
          margin-top: 10px;
          font-weight: 600;
          cursor: pointer;
        ">
          Cancel
        </button>

        <div style="
          text-align: center;
          margin-top: 14px;
          font-size: 0.9rem;
          color: #475569;
        ">
          Continue as
          <a href="#" style="color: #0d9488; font-weight: bold; text-decoration: none;">Guest</a>
        </div>

        <div style="
          text-align: center;
          margin-top: 8px;
          font-size: 0.85rem;
          color: #475569;
        ">
          <a (click)="goHome()" style="color: #0d9488; font-weight: bold; text-decoration: none;">Back to Home</a>
        </div>
      </form>
    </div>
  </div> -->



    <!--Registration form-->
    <div class="mt-5 mb-5" *ngIf="isRegistration && !isMainScreen && !globals.IsUserDetailsUpdate">
      <div class="d-flex align-items-center justify-content-between">
        <div class="login-block register-content shadow-box border mx-auto position-relative">
          <!-- <div class="login-icon mb-4 mt-2">
          <span class="square-100 fa-notify"><i class="fa fa-unlock-alt"></i></span>
        </div> -->
          <div class="d-flex justify-content-center mb-1">
            <img class="newLogo" src="/assets/img/New Logo - Transperent.png" width="80" height="80" alt="" />
          </div>
          <div class="grid-b-space text-center">
            <p class="pclass text-primary mb-2 responsive-text letter-space-1.5" style="line-height: 22px;">
              Welcome To Nisargopchar Ashram
            </p>
            <h2 class="text-dark fontsizeandfamilyCalibri">Register with Us</h2>
          </div>
          <form #ngForm="ngForm" class="login-form" novalidate>
            <div *ngIf="!IsRegistrationDone">
              <div class="row d-none">
                <div class="col-md-4">
                  <div class="form-group">
                    <!--First Name-->
                    <strong class="text-left">First Name</strong>
                    <input class="form-control" type="text" placeholder="First Name" (input)="
                    UpperCase(OnlineUserRegistration.FirstName, 'FirstName');
                    TrimName(OnlineUserRegistration.FirstName, 'FirstName')
                  " name="FirstName" [(ngModel)]="OnlineUserRegistration.FirstName" required />
                    <small *ngIf="
                    ngForm.form.controls['FirstName']?.invalid &&
                    ngForm.form.controls['FirstName']?.touched
                  " class="text-danger">
                      You must include a first name.
                    </small>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <!--Middle Name-->
                    <strong class="text-left">Middle Name</strong>
                    <input class="form-control" type="text" placeholder="Middle Name" (input)="
                    UpperCase(OnlineUserRegistration.MiddleName, 'MiddleName');
                    TrimName(OnlineUserRegistration.MiddleName, 'MiddleName')
                  " name="middleName" [(ngModel)]="OnlineUserRegistration.MiddleName" />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <!--Last Name-->
                    <strong class="text-left">Last Name</strong>
                    <input class="form-control" type="text" placeholder="Last Name" (input)="
                    UpperCase(OnlineUserRegistration.LastName, 'LastName');
                    TrimName(OnlineUserRegistration.LastName, 'LastName')
                  " name="lastName" [(ngModel)]="OnlineUserRegistration.LastName" required />
                    <small *ngIf="
                    ngForm.form.controls['lastName']?.invalid &&
                    ngForm.form.controls['lastName']?.touched
                  " class="text-danger">
                      You must include a last name.
                    </small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md">
                  <div class="form-group">
                    <!--Email-->
                    <strong class="text-left">Email</strong>
                    <div class="d-flex align-items-center">
                      <!--Email-->
                      <input type="text" class="form-control" placeholder="Email Address" name="email" id="UserREmail"
                        [(ngModel)]="OnlineUserRegistration.Email" [disabled]="IsEmailVerified"
                        (input)="clearFieldError('Email'); validateEmail(OnlineUserRegistration.Email)" required
                        email /><br />
                    </div>
                    <small *ngIf="
                      !this.ValidEmail &&
                      ngForm.form.controls['email']?.invalid &&
                      ngForm.form.controls['email']?.touched
                    " class="text-danger">
                      You must include a valid email address.
                    </small>
                    <small *ngIf="fieldErrors['Email']" class="text-danger">
                      {{ fieldErrors['Email'] }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md">
                  <div class="form-group d-flex flex-column">
                    <strong class="text-left">Mobile Number</strong>
                    <div class="form-group">
                      <!--mobile No-->
                      <input class="form-control" type="text" placeholder="Mobile Number" name="mobileNo" id="mobileNo"
                        [(ngModel)]="OnlineUserRegistration.MobileNo" pattern="[0-9]{10}" [disabled]="IsEmailVerified"
                        (input)="clearFieldError('Mobile');" (keypress)="validateService.numberOnly($event)"
                        maxlength="10" required autocomplete="off" />
                      <!-- <div class="input-group-append">
                    <span class="input-group-text password-toggle" (click)="GetGSMasWAGSM(isWAGSM, 'User')">
                      <i class="fa fa-whatsapp" style="color: green" title="WhatsApp Connected?"></i>
                    </span>
                  </div> -->
                    </div>
                    <small *ngIf="
                    ngForm.form.controls['mobileNo']?.invalid &&
                    ngForm.form.controls['mobileNo']?.touched
                  " class="text-danger">
                      You must include a Mobile Number.
                    </small>
                    <small *ngIf="fieldErrors['Mobile']" class="text-danger">
                      {{ fieldErrors['Mobile'] }}
                    </small>
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <!--WhatsApp Mobile Number-->
                  <strong class="text-left">WhatsApp Mobile Number</strong>
                  <div class="form-group d-flex flex-column">
                    <input type="text" name="WAGSMR" id="WAGSMR" class="form-control"
                      placeholder="WhatsApp Mobile Number" (keypress)="validateService.numberOnly($event)"
                      maxlength="10" [(ngModel)]="OnlineUserRegistration.WhatsAppNo" required />
                  </div>
                </div>
                <div class="col-md-4 d-none">
                  <!--Country-->
                  <div class="form-group">
                    <strong class="text-left">Country</strong>
                    <div class="d-flex align-items-center">
                      <input type="text" name="CountryR" id="CountryR" class="form-control"
                        [(ngModel)]="OnlineUserRegistration.Country" placeholder="Country" [matAutocomplete]="autoC" />
                      <mat-autocomplete #autoC="matAutocomplete">
                        <mat-option *ngFor="
                        let City of CountryandNationality
                          | filter : OnlineUserRegistration.Country
                      " [value]="City['Country']" title="{{ City['Country'] }}">
                          {{ City["Country"] }}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row d-none">

                <div class="col-md-4">
                  <!--State-->
                  <div class="form-group">
                    <strong class="text-left">State</strong>
                    <div class="d-flex align-items-center">
                      <input type="text" name="StateR" id="StateR" class="form-control"
                        [(ngModel)]="OnlineUserRegistration.State" placeholder="State" [matAutocomplete]="autoState" />
                      <mat-autocomplete #autoState="matAutocomplete">
                        <mat-option *ngFor="
                        let state of States
                          | filter : OnlineUserRegistration.State;
                        trackBy: trackByFn
                      " (onSelectionChange)="
                        GetDistrictList($event); GetCityList($event, 'User')
                      " [value]="state['State']" title="{{ state['State'] }}">
                          {{ state["State"] }}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group text-left">
                    <!----- District ------>
                    <strong class="text-left">District</strong>
                    <input type="text" name="District" id="District" class="form-control"
                      [matAutocomplete]="autoDistrict1" [(ngModel)]="itemToEdit.District" placeholder="District" />
                  </div>
                  <mat-autocomplete #autoDistrict1="matAutocomplete">
                    <mat-option *ngFor="
                    let cc of District
                      | filter : OnlineUserRegistration.District;
                    trackBy: trackByFn
                  " (onSelectionChange)="GetCityList($event, 'User')" [value]="cc['District']"
                      title="{{ cc['District'] }}">
                      {{ cc["District"] }}
                    </mat-option>
                  </mat-autocomplete>
                </div>

                <div class="col-md-4">
                  <!--City-->
                  <div class="form-group">
                    <strong class="text-left">City</strong>
                    <div class="d-flex align-items-center">
                      <input type="text" name="CityR" id="CityR" class="form-control"
                        [(ngModel)]="OnlineUserRegistration.City" placeholder="City" [matAutocomplete]="autoCity" />
                      <mat-autocomplete #autoCity="matAutocomplete">
                        <mat-option *ngFor="
                        let aa of City | filter : OnlineUserRegistration.City;
                        trackBy: trackByFn
                      " [value]="aa['City']" title="{{ aa['City'] }}">
                          {{ aa["City"] }}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <div class="col-md-4 position-relative d-none">
                  <div class="form-group d-flex flex-column">
                    <strong class="text-left">User Name</strong>
                    <div class="d-flex align-items-center w-100">
                      <input class="form-control" type="text" placeholder="User Name" name="UserNameRegister"
                        id="UserNameRegister" [(ngModel)]="OnlineUserRegistration.UserID" #UserName="ngModel"
                        minlength="3" [disabled]="IsOTPSent" required
                        (input)="clearFieldError('UserID'); validateUsername(OnlineUserRegistration.UserID)"
                        (focus)="showSuggestions = true" (blur)="hideSuggestions()"
                        (keypress)="validateService.validateUserName($event)" />
                      <!-- Info Icon -->
                      <span class="info-icon ms-2">
                        <i class="fa-solid fa-circle-info"></i>
                        <div class="tooltip-box">
                          <ul class="validation-rules">
                            <li [class.valid]="usernameRules.length">3–20 characters</li>
                            <li [class.valid]="usernameRules.startWithLetter">Starts with a letter</li>
                            <li [class.valid]="usernameRules.allowedChars">
                              Only letters, numbers, underscore (_) or dot (.)
                            </li>
                          </ul>
                        </div>
                      </span>
                    </div>

                    <!-- Error Message -->
                    <small *ngIf="UserName?.invalid && UserName?.touched" class="text-danger">
                      You must include a valid user name.
                    </small>
                    <small *ngIf="fieldErrors['UserID']" class="text-danger">
                      {{ fieldErrors['UserID'] }}
                    </small>

                    <!-- Username Suggestions Dropdown -->
                    <div *ngIf="showSuggestions && Suggestion?.length > 0" class="suggestion-dropdown">
                      <div *ngFor="let s of Suggestion" (mousedown)="selectSuggestion(s)" class="suggestion-item">
                        <i class="fa-regular fa-user me-2 text-primary mr-1"></i> {{ s }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-5">
                  <button type="button" [disabled]="!this.ValidEmail"
                    *ngIf="IsOTPSent == false && IsEmailVerified == false"
                    class="btn btn-primary btn-block btn-lg btn-square" (click)="VerifyUserEmail('Verify')">
                    <i [ngClass]="
                    isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''
                  "></i>
                    Send OTP
                  </button>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <div class="form-group" *ngIf="!IsEmailVerified">
                  <!--OTP-->
                  <!-- <strong class="text-left">OTP</strong> -->
                  <div class="otp-inputs"> <!--OTP-->
                    <input *ngFor="let digit of otp; let i = index" type="text" maxlength="1" [value]="otp[i]"
                      (input)="onInputR($event, i)" (keypress)="validateService.numberOnly($event)"
                      (keydown)="onKeyDownR($event, i)" #otpInput [disabled]="!IsOTPSent" />
                  </div>
                  <small *ngIf="
                      ngForm.form.controls['otp']?.invalid &&
                      ngForm.form.controls['otp']?.touched
                    " class="text-danger">
                    You must include OTP.
                  </small>
                  <small *ngIf="fieldErrors['vOTP']" class="text-danger">
                    {{ fieldErrors['vOTP'] }}
                  </small>
                </div>
              </div>
              <div class="row">
                <div class="col-md">
                  <div class="form-group" *ngIf="IsEmailVerified == true">
                    <!--Password-->
                    <strong class="text-left">Set Password</strong>
                    <div class="d-flex align-items-center">
                      <input type="password" name="Password" class="form-control" placeholder="Enter Password"
                        [(ngModel)]="OnlineUserRegistration.Password" required /><br />
                    </div>
                    <small *ngIf="
                      ngForm.form.controls['Password']?.invalid &&
                      ngForm.form.controls['Password']?.touched
                    " class="text-danger">
                      You must include a password.
                    </small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md">
                  <div class="form-group" *ngIf="IsEmailVerified == true">
                    <!--Confirm Password-->
                    <strong class="text-left">Confirm Password</strong>
                    <div class="d-flex align-items-center">
                      <input type="password" name="ConfirmPassword" class="form-control"
                        (input)="clearFieldError('PassMiss');" placeholder="Enter Confirm Password"
                        [(ngModel)]="OnlineUserRegistration.ConfirmPassword" required /><br />
                    </div>
                    <small *ngIf="
                      ngForm.form.controls['ConfirmPassword']?.invalid &&
                      ngForm.form.controls['ConfirmPassword']?.touched
                    " class="text-danger">
                      You must include a Confirm password.
                    </small>
                    <small *ngIf="fieldErrors['PassMiss']" class="text-danger">
                      {{ fieldErrors['PassMiss'] }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center align-items-center">
                <div class="col-md-6">
                  <div class="form-group" *ngIf="IsEmailVerified == false && IsOTPSent == true">
                    <button type="button" (click)="VerifyOTP(OnlineUserRegistration.Email, OTP, 'Verify')"
                      class="btn btn-primary btn-block btn-lg btn-square mt-2">
                      <i [ngClass]="
                    isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''
                  "></i>
                      Verfiy with OTP
                    </button>
                    <small *ngIf="fieldErrors['VerifyOTP']" class="text-danger">
                      {{ fieldErrors['VerifyOTP'] }}
                    </small>
                  </div>
                </div>
              </div>
              <div class="form-group text-center">
                <div class="mb-3 d-flex justify-content-center">
                  <button type="button" (click)="register('R')"
                    [disabled]="(ngForm.form?.invalid || !IsEmailVerified) && (OnlineUserRegistration.Password == '' || OnlineUserRegistration.ConfirmPassword == '')"
                    class="btn btn-primary btn-block btn-lg btn-square col-md-4">
                    <i [ngClass]="
                  isInProgressRegister
                    ? 'spinner-border spinner-border-sm mr-1'
                    : ''
                "></i>
                    Register</button><!--Register-->
                </div>
                <small *ngIf="fieldErrors['RegisterU']" class="text-danger">
                  {{ fieldErrors['RegisterU'] }}
                </small>
              </div>
              <div class="text-center">
                <span>If already registered ? <a (click)="GetRegistartion()" class="text-primary">Sign in
                  </a> here</span><!--Sign in here-->
              </div>
            </div>
            <div *ngIf="IsRegistrationDone">
              <h2 class="text-success text-center mt-3">Registration Successful!</h2>
              <div>Your Registered Email is <b>{{UserEmail}}</b></div>
              <div>Your Registered Mobile No is <b>{{UserMobile}}</b></div>
              <p>Thank you for registering with Nisargopchar Ashram.</p>
              <button class="btn btn-outline-primary mt-3" (click)="GetRegistartion()">Go to Login</button>
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="section == 'booking-login-register'">
    <!-- Guest List -->
    <div class="guest-list-section" *ngIf="
      issignin &&
      !isRegistration &&
      !isregister &&
      !isbooknow &&
      !isBookingHistory &&
      !globals.isPaymentHistory &&
      !isBookingQuetionary &&
      !IsPatientHistorySheet &&
      !globals.IsUserDetailsUpdate
    ">
      <div class="container mt-2">
        <div class="d-flex justify-content-between align-items-center mx-auto" style="width: 66%">
          <h1 class="d-flex align-items-start" style="font-family: sans-serif; font-size: 2em">
            Guest list
          </h1>
          <!-- Right Div with Add New Button -->
          <div class="d-flex justify-content-end align-items-center mb-2">
            <button class="btn" title="Add New Patient/Guest" style="
              font-family: sans-serif;
              font-size: 1.16em;
              background-color: #77c5ec;
            " (click)="AddNew(content); GetsigninDetails('Addbutton')">
              <strong>Add New Patient/Guest</strong>
            </button>
          </div>
        </div>
        <div class="container mt-2 d-flex justify-content-center">
          <div class="chk-block-content mt-2" style="width: 85%;">
            <div class="table-responsive">
              <div class="unseen d-flex justify-content-center">
                <table class="table table-striped table-hover text-left" data-filtering="true" data-sorting="true"
                  style="max-width:80%">
                  <thead>
                    <tr style="
                      font-family: sans-serif;
                      font-size: 1.16em;
                      background-color: #77c5ec;
                    ">
                      <th style="
                        min-width: 30px !important;
                        max-width: 30px !important;
                      ">
                        No.
                      </th>
                      <th>Guest Name</th>
                      <th>Address</th>
                      <th>Status</th>
                      <th>Guest Action</th>
                      <th>Booking Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="
                      font-family: Calibri;
                      font-size: 1.16em;
                      background-color: #e3ebdc;
                    " *ngFor="
                      let item of items
                        | filter : filters
                        | paginate : { itemsPerPage: 10, currentPage: page };
                      let i = index
                    ">
                      <td style="
                        min-width: 20px !important;
                        max-width: 20px !important;
                      ">
                        {{ 10 * (page - 1) + i + 1 }}
                      </td>
                      <td>
                        <div class="col-lg" style="font-size: 1.2rem; font-weight: bold;">
                          {{ item.GuestName }}
                        </div>
                        <div class="col-lg" style="font-size: 0.95rem;">
                          <b>DOB:</b> {{ item.DateOfBirth | date: 'dd-MMM-yyyy' }},
                          <b>Age:</b> {{ item.Age1 }},
                          <b>Gender:</b> {{ item.Gender }}
                        </div>
                      </td>
                      <td>{{ item.City }}</td>
                      <td [style]="
                        item.BookingStatus == 'Unutilized by the Patient/guest'
                          ? 'background-color: green;color: white;'
                          : item.BookingStatusHold != ''
                          ? 'background-color: #efdd20;color: black;'
                          : 'background-color: #fd7f33;color: white;'
                      ">
                        <label style="margin-bottom: 0">
                          {{
                          item.BookingStatus ==
                          "Unutilized by the Patient/guest"
                          ? "Booking Done"
                          : item.BookingStatus == "Booking Pending"
                          ? "Booking Pending"
                          : item.BookingStatusHold != ''
                          ? item.BookingStatusHold
                          : "No Booking"
                          }}
                        </label>
                      </td>
                      <td class="font text-nowrap style=min-width: 30px !important; max-width: 30px !important;">
                        <button class="btn btn-primary fa-sm mr-1" style="background-color: #9fc7e8; color: #282727;"
                          (click)="ViewGuest(item.OnlinePatientRegistrationID,content,item.AadharNo,item.PassportNo,item.Nationality);">
                          Modify
                        </button> <br>
                        <button class="btn btn-primary fa-sm mr-1 mt-2"
                          [style.background-color]="item.Activate ? '#f25f5c' : '#4caf50'"
                          [style.color]="item.Activate ? '' : '#282727'"
                          title="{{item.Activate ? 'Deactivate Guest' : 'Activate Guest'}}" (click)="ActivateDeactivateById(
                            item.OnlinePatientRegistrationID,
                            item.Activate,
                            item.Nationality,
                            item.AadharNo,
                            item.PassportNo,
                            item.PatientID,
                            item.GuestName)">
                          {{item.Activate ? 'Deactivate' : 'Activate'}}
                        </button>
                      </td>
                      <td class="font style=min-width: 30px !important; max-width: 30px !important;">
                        <button class="btn btn-primary fa-sm mr-1" title="New booking details"
                          style="background-color: #f3db98; color: #282727;"
                          *ngIf="item.Activate && item.BookingStatus !== 'Unutilized by the Patient/guest' && item.BookingStatus !== 'Booking Pending' && item.BookingStatusHold == ''"
                          (click)="
                          item.BookingStatus !==
                            'Unutilized by the Patient/guest' && !isInProgress ? GetcheckFunction(item.GuestName,item.OnlinePatientRegistrationID,item.AadharNo,item.PassportNo,item.Nationality) : null">
                          <i [ngClass]="
                          isInProgress
                            ? 'spinner-border spinner-border-sm mr-1'
                            : ''"></i>
                          New Booking
                        </button>

                        <button class="btn btn-primary fa-sm mr-1" title="Upload Documents"
                          style="background-color: #f3db98; color: #282727;"
                          *ngIf="item.Activate && item.BookingStatusHold != ''"
                          (click)="AttachDocument(contentDocument, item.OnlinePatientRegistrationID)">
                          <i [ngClass]="
                          isInProgress
                            ? 'spinner-border spinner-border-sm mr-1'
                            : ''"></i>
                          Upload Documents
                        </button>
                        <br>
                        <div class="mb-2"
                          *ngIf="!item.Activate || item.BookingStatus == 'Unutilized by the Patient/guest' || item.BookingStatus == 'Booking Pending'">
                        </div>
                        <button class="btn btn-primary fa-sm mr-1 mt-2"
                          style="background-color: #d5b6fd; color: #282727;" title="Booking history" (click)="
                          GetBookingHistory(
                            item.OnlinePatientRegistrationID,
                            item.AadharNo,
                            item.PassportNo,
                            item.Nationality)">
                          Booking History
                        </button>
                        <button class="btn btn-primary fa-sm mr-1 mt-2"
                          style="background-color: #89e0da; color: #282727;" title="Payment History" (click)="
                          GetPaymentHistory(
                            item.OnlinePatientRegistrationID,
                            item.AadharNo,
                            item.PassportNo,
                            item.Nationality)">
                          Payment History
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <pagination-controls (pageChange)="page = $event" [maxSize]="10" [directionLinks]="true" [autoHide]="true"
                [responsive]="true">
              </pagination-controls>
              <!----- Page No ------>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!---Booking History-->
    <div class="container booking-history-section ttm-bgcolor-whiteecolor" style="width: 70%;"
      *ngIf="isBookingHistory && !globals.IsUserDetailsUpdate">
      <div class="row mt-3 fontsizeandfamilyCalibri">
        <div class="col-auto">
          <button type="button" class="btn btn-square bg-dark" style="color: #ffffff" title="Click to go back" *ngIf="(
        ((!isMainScreen && !isRegistration && !issignin) ||
        isBookingQuetionary ||
        isBookingHistory ||
        globals.isPaymentHistory ||
        isregister ||
        isbooknow) &&
        !isFinalPayment) ||
        IsUserDetailsType == 'click' ||
        (BookingHistory.length > 0 && IsPatientHistorySheet)" (click)="GetBack()">
            <i class="fa fa-lg fa-arrow-left" aria-hidden="true"></i> Back
          </button>
        </div>

        <div class="col-lg">
          <div class="grid-b-space">
            <div class="row">
              <div class="col-md-3 text-right mt-2">
                <label id="lblGuestName">Guest Name</label><!--Guest Name-->
              </div>
              <div class="col-md-5 text-left mt-2">
                <strong>{{ GuestName }}</strong>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 text-right mt-2">
                <label id="lblExpectedcheckin">Date of birth</label>
                <!--Expected check-in-->
              </div>
              <div class="col-md-5 text-left mt-2">
                <strong>{{
                  GuestQuetionaridetails[0].DateOfBirth | date : "dd-MMM-yyyy"
                  }}</strong>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 text-right mt-2">
                <label id="lblExpectedcheckout">Age</label><!--Expected check-out-->
              </div>
              <div class="col-md-5 text-left mt-2">
                <strong>{{ GuestQuetionaridetails[0].Age }}</strong>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg">
          <div class="row">
            <div class="col-md-3 text-right mt-2">
              <label id="lblNoofdays">Sex</label><!----No. of days---->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{ GuestQuetionaridetails[0].Gender }}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-right mt-2">
              <label id="lblAccomodation">Address</label><!--Accomodation-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{ GuestQuetionaridetails[0].City }}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-right mt-2">
              <label id="lblEmail">E-mail</label><!--E-mail-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{ UserEmail }}</strong>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4 justify-content-center">
        <div class="table-responsive">
          <div class="unseen fontsizeandfamilyCalibri">
            <table class="table table-striped table-hover text-left" data-page-size="15" data-filtering="true"
              data-sorting="true">
              <thead>
                <tr style="background-color: #77c5ec">
                  <th style="min-width: 20px !important; max-width: 20px !important">
                    No.
                  </th>
                  <th>Booking Code</th>
                  <th>Booking Date</th>
                  <th>Check-in</th>
                  <th>Check-out</th>
                  <th>Days</th>
                  <th>Accomodation</th>
                  <th>Status</th>
                  <th class="numeric text-center">Action</th>
                  <!-- <td class="numeric text-center">Action</td> -->
                </tr>
              </thead>
              <tbody>
                <tr style="background-color: #e3ebdc" *ngFor="
                  let item of BookingHistory
                    | filter : filters
                    | paginate : { itemsPerPage: 10, currentPage: Historypage };
                  let i = index
                ">
                  <td style="min-width: 20px !important; max-width: 20px !important">
                    {{ 10 * (Historypage - 1) + i + 1 }}
                  </td>
                  <td>{{ item.BookingCode }}</td>
                  <td>{{ item.BookingDate }}</td>
                  <td>{{ item.CheckinDate }}</td>
                  <td>{{ item.CheckOutDate }}</td>
                  <td>{{ item.AdmissionDuration }}</td>
                  <td>{{ item.ClassName }}</td>
                  <td>{{ item.BookingStatus }}</td>
                  <td class="numeric text-center">
                    <i class="fa fa-lg fa-list mr-1" title="Patient History Form" *ngIf="
                      item.BookingStatus != 'Cancellation' &&
                      item.AdmissionID == 0
                    " (click)="
                      GetPatientHistoryQuestionary(
                        item.OnlinePatientRegistrationID
                      )
                    "></i>
                    <i class="fa-lg fa fa-calendar mr-2 text-success" title="Reschedule Booking"
                      (click)="RescheduleBooking(item, item.BookingID)" *ngIf="item.CarryforwardBookingID == 0 &&
                      item.BookingStatus != 'Cancellation' &&
                      item.AdmissionID == 0
                    "></i>
                    <i *ngIf="
                      item.BookingStatus != 'Cancellation' &&
                      item.AdmissionID == 0
                    " class="fa-lg fa fa-trash mr-2 text-danger" title="Cancelation Booking" (click)="
                      DeactivateBookingID(
                        contentCancellation,
                        item.PatientID,
                        item.BookingID,
                        item.CheckinDate,
                        item.AdvanceAmount,
                        item.GuestEmail,
                        item.BookingCode
                      )
                    "></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination-controls (pageChange)="Historypage = $event" [maxSize]="10" [directionLinks]="true"
            [autoHide]="true" [responsive]="true">
          </pagination-controls>
          <!----- Page No ------>
        </div>
      </div>
      <!-- <div class="row mt-2 d-flex justify-content-end fontsizeandfamilyCalibri">
      <button class="btn btn-success fa-sm ml-5 mt-1" (click)="LoadGuest()">
        Guest List
      </button>
    </div> -->
    </div>

    <!---Payment History-->
    <div class="container ttm-bgcolor-whiteecolor" style="width: 70%;"
      *ngIf="globals.isPaymentHistory && !globals.IsUserDetailsUpdate">
      <app-payment-history [selectedOnlinePatientRegistrationID]="
        SelectedOnlinePatientRegistrationID
      " [CarmePaymentGateway_key]="CarmePaymentGateway_key"
        [CarmePaymentGateway_secret]="CarmePaymentGateway_secret"></app-payment-history>
    </div>

    <!--- Check Availability and Booking-->
    <div class="d-flex justify-content-center align-items-center">
      <div class="ttm-bgcolor-whiteecolor mt-1 fontsizeandfamilyCalibri" style="width: 70%;" *ngIf="
      !isRegistration &&
      isregister &&
      !isbooknow &&
      !isFinalPayment &&
      !isBookingQuetionary &&
      !globals.IsUserDetailsUpdate
    ">

        <!--Courses landing-->
        <div class="container course-wrap">
          <div class="banner-wrap pt-4">
            <div class="">
              <div class="banner-content">
                <div class="row mb-2">
                  <div class="col-auto">
                    <button type="button" class="btn btn-square bg-dark" style="color: #ffffff" title="Click to go back"
                      *ngIf="(
                      ((!isMainScreen && !isRegistration && !issignin) ||
                      isBookingQuetionary ||
                      isBookingHistory ||
                      globals.isPaymentHistory ||
                      isregister ||
                      isbooknow) &&
                      !isFinalPayment) ||
                      IsUserDetailsType == 'click' ||
                      (BookingHistory.length > 0 && IsPatientHistorySheet)" (click)="GetBack()">
                      <i class="fa fa-lg fa-arrow-left" aria-hidden="true"></i> Back
                    </button>
                  </div>

                  <div class="col-md-5">
                    <div class="row">
                      <div class="col-md-6 text-right mt-2">
                        <strong id="lblGuestName">Guest/Patient Name</strong>
                      </div>
                      <div class="col-md-6 text-left mt-2">
                        <span>{{ GuestName }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 text-right mt-2">
                        <strong id="lblAge">Age</strong>
                      </div>
                      <div class="col-md-6 text-left mt-2">
                        <span>{{ GuestQuetionaridetails[0]?.Age }}</span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 text-right mt-2">
                        <strong id="lblGuestName">Gender</strong>
                      </div>
                      <div class="col-md-6 text-left mt-2">
                        <span>{{ GuestQuetionaridetails[0]?.Gender }}</span>
                      </div>
                    </div>


                  </div>
                  <div class="col-md-5">
                    <div class="row">
                      <div class="col-md-6 text-right mt-2">
                        <strong class="mr-2">Check-in Date</strong>
                      </div>
                      <div class="col-md-6 text-left mt-2">
                        <div class="input-group">
                          <input matInput [matDatepicker]="picker" [(ngModel)]="checkinDateD" [min]="Today"
                            [max]="maxDate()" class="form-control w-auto" [matDatepickerFilter]="disableSundays"
                            (dateChange)="bedData = [];" disabled />
                          <span class="input-group-append">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker disabled="false" #picker></mat-datepicker>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6 text-right mt-2">
                        <strong id="lblDuration">Duration</strong>
                      </div>
                      <div class="col-md-6 text-left mt-2">
                        <select class="form-control" [(ngModel)]="AdmissionDuration">
                          <!-- <option *ngFor="
                          let day of [
                            7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
                            21
                          ]
                        " [value]="day">
                            {{ day }}
                          </option> -->
                          <option *ngFor="let duration of AdmissionDurationRange" [value]="duration.Description">
                            {{ duration.Description }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 text-right mt-2">
                        <strong id="lblRoomCategory">Room Category</strong>
                      </div>
                      <div class="col-md-6 text-left mt-2">
                        <select class="form-select form-control" name="RoomCategory1" id="RoomCategory1"
                          [(ngModel)]="RoomCategory" (change)="onRoomCategoryChange($event)"
                          title="Select Room Category">
                          <option [value]="0">All</option>
                          <option *ngFor="let roomc of RoomCategoryList" [value]="roomc.ClassID"
                            [attr.data-name]="roomc['Healing retreat']">
                            {{ roomc["Healing retreat"] }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                  <div class="col-auto mt-2 mb-2">
                    <button type="button" class="btn btn-success btn-block" (click)="
                        RoomCategory == 0
                          ? CheckAvailability()
                          : GetRecommendedBookingDates(RoomCategory)
                      ">
                      <i [ngClass]=" isInProgress ? 'spinner-border spinner-border-sm mr-1' : 'fa fa-search mr-1'"
                        aria-hidden="true"></i>
                      Search
                    </button>
                  </div>
                  <div class="col-auto mt-2 mb-2">
                    <button class="btn btn-secondary btn-block" (click)="ClearBedFilter()">
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Filters-->
          <div class="courses-content-wrap mt-3 fontsizeandfamilyCalibri">
            <div class="container" *ngIf="
            errorMessage == '' &&
            bedData.length > 0 &&
            RecommendedBookingDatesList.length == 0
          ">
              <div class="degree-wrap">
                <div class="row justify-content-center">
                  <ng-container *ngFor="let room of bedData; let i = index;">
                    <div class="col-12 col-sm-12 col-md-6 col-lg-3 grid-b-space">
                      <div class="card shadow-box border">
                        <figure class="imghvr-zoom-in">
                          <a class="p-cursor" (click)="GetBookNow(room, i)">
                            <img class="img-fluid" alt="example-image" [src]="room.ImgURL" />
                          </a>
                        </figure>
                        <div class="card-body" (click)="GetBookNow(room, i)">
                          <div class="sec-content text-left">
                            <strong> {{ room["Healing retreat"] }}</strong><br />
                            <strong>Vacant Bed Count:- </strong><label>{{ GetlowestNumber(room) }} </label><br />
                            <strong>Rate:- </strong><label> {{ room[headers[1]] }} </label>
                            <i [ngClass]="
                            IsSpin && Index == i
                              ? 'spinner-border spinner-border-sm mr-1' : ''"></i>
                          </div>
                        </div>
                        <div class="card-custom-footer">
                          <div class="course-footer-descp">
                            <span class="footer-shape d-flex align-items-center justify-content-start"><i
                                class="fa fa-certificate mx-3" aria-hidden="true"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <h1 class="text-danger" *ngIf="errorMessage != '' && BookingCount == -1">
              {{ errorMessage }}
            </h1>
            <h1 class="text-danger" *ngIf="errorMessage != '' && BookingCount >= 40">
              {{ errorMessage }}
            </h1>
            <h1 class="text-danger" *ngIf="Nobedforthisrange && bedData.length == 0">
              {{ errorMessage }}
            </h1>
            <!--Recommended Booking Dates-->
            <!-- <div class="courses-grid-slider py-4" dir="ltr" *ngIf="RecommendedBookingDatesList.length > 0">
        <div class="container">
          <div class="sec-title mrgn-b-2">
            <h4 class="font-weight-light"><span class="font-2x">{{'Recommended Booking Dates'|translate}}</span></h4>
          </div>
          <div class="row mb-4" *ngIf="RecommendedBookingDatesList.length > 0">
            <div class="col-12">
              <div class="d-flex overflow-auto flex-nowrap pb-2 px-2">
                <ng-container *ngFor="let row of RecommendedBookingDatesList">
                  <div class="flex-shrink-0" style="margin-right: 12px;">
                    <button type="button" class="btn" style="min-width: 160px;" class="btn-outline-primary">
                      {{row.StartDate | date: 'dd-MM-yyyy'}}
                    </button>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div> -->

            <div class="courses-grid-slider py-4" dir="ltr" *ngIf="RecommendedBookingDatesList.length > 0">
              <div class="container">
                <div class="sec-title mrgn-b-2">
                  <h4 class="font-weight-light">
                    <span class="font-2x">{{
                      "Recommended Booking Dates" | translate
                      }}</span>
                  </h4>
                </div>
                <div class="row mb-4">
                  <div class="col-12 d-flex align-items-center">
                    <!-- Left Arrow (clickable) -->
                    <div class="arrow-icon" (click)="scrollLeft()">
                      <i class="fa-lg fa-solid fa-chevron-left"></i>
                    </div>
                    <!-- Scrollable Container -->
                    <div #scrollContainer class="date-scroll-container d-flex overflow-auto flex-nowrap pb-2 px-2"
                      style="gap: 12px">
                      <ng-container *ngFor="let row of RecommendedBookingDatesList">
                        <div class="flex-shrink-0">
                          <button type="button" class="btn btn-outline-dark" (click)="GetRecommendedDateBooking(row)"
                            style="
                          min-width: 160px;
                          height: 80px;
                          border-radius: 12px;
                        ">
                            <div class="fw-bold fontsizeandfamilyCalibri">
                              <strong>{{ row.StartDate | date : "EEE" }}</strong>
                            </div>
                            <div class="fontsizeandfamilyCalibri">
                              <strong>{{ row.StartDate | date : "dd MMM" }}</strong>
                            </div>
                          </button>
                        </div>
                      </ng-container>
                    </div>
                    <!-- Right Arrow (clickable) -->
                    <div class="arrow-icon" (click)="scrollRight()">
                      <i class="fa-lg fa-solid fa-chevron-right"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Accommodation And Payment Details -->
    <div class="container pt-4" style="width: 70%;" *ngIf="isbooknow && !globals.IsUserDetailsUpdate">

      <div class="row fontsizeandfamilyCalibri">
        <div class="col-auto">
          <button type="button" class="btn btn-square bg-dark" style="color: #ffffff" title="Click to go back" *ngIf="(
            ((!isMainScreen && !isRegistration && !issignin) ||
            isBookingQuetionary ||
            isBookingHistory ||
            globals.isPaymentHistory ||
            isregister ||
            isbooknow) &&
            !isFinalPayment) ||
            IsUserDetailsType == 'click' ||
            (BookingHistory.length > 0 && IsPatientHistorySheet)" (click)="GetBack()">
            <i class="fa fa-lg fa-arrow-left" aria-hidden="true"></i> Back
          </button>
        </div>
        <div class="col-lg">
          <div class="grid-b-space">
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblGuestName">Guest Name</strong><!--Guest Name-->
              </div>
              <div class="col-md-7 text-left mt-2">
                <!-- <input type="text" class="form-control" name="GuestName" autocomplete="off" id="GuestName"
                  [(ngModel)]="GuestName" disabled /> -->

                <span>{{ GuestName }}</span>


              </div>
            </div>
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblExpectedcheckin">Expected check-in</strong>
                <!--Expected check-in-->
              </div>
              <div class="col-md-7 text-left mt-2">
                <!-- <input type="date" class="form-control" name="Expectedcheckin" autocomplete="off" id="Expectedcheckin"
                  [(ngModel)]="checkinDate" [min]="Today" disabled /> -->
                <span>{{checkinDate}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblExpectedcheckout">Expected check-out</strong><!--Expected check-out-->
              </div>
              <div class="col-md-7 text-left mt-2">
                <!-- <input type="date" class="form-control" name="Expectedcheckout" autocomplete="off" id="Expectedcheckout"
                  [(ngModel)]="checkoutDate" disabled /> -->

                <span>{{checkoutDate}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblNoofdays">No. of days</strong><!----No. of days---->
              </div>
              <div class="col-md-7 text-left mt-2">
                <!-- <input type="" class="form-control" name="Noofdays" autocomplete="off" id="Noofdays"
                  [(ngModel)]="AdmissionDuration" disabled /> -->

                <span>{{AdmissionDuration}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblAccomodation">Accomodation</strong><!--Accomodation-->
              </div>
              <div class="col-md-7 text-left mt-2">
                <!-- <input type="text" class="form-control" name="Accomodation" autocomplete="off" id="Accomodation"
                  [(ngModel)]="selectedAliesName" disabled /> -->

                <span>{{selectedAliesName}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblRate">Accommodation Charges</strong><!--Room rents and treatment charges-->
              </div>
              <div class="col-md-7 text-left mt-2">
                <!-- <input type="text" class="form-control" name="Rate" autocomplete="off" id="Rate"
                  [(ngModel)]="selectedRate" disabled /> -->

                <span>{{selectedRate}}</span>
              </div>

            </div>
          </div>
        </div>
        <div class="col-lg">
          <div class="row">
            <div class="col-md-4 text-right mt-2">
              <strong id="lblPaymentDate">Payment Date</strong><!--Payment Date/Time-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <!-- <input type="text" class="form-control" [ngModel]="Today | date : 'dd-MM-yyyy'" name="PaymentDate"
                autocomplete="off" id="PaymentDate" disabled /> -->

              <span>{{Today}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-right mt-2">
              <strong id="lblAmount">Amount (Rs.)</strong><!--Amount (Rs.)-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <!-- <input type="text" class="form-control" name="Amount" [(ngModel)]="TotalAmount" autocomplete="off"
                id="Amount" disabled /> -->

              <span>{{TotalAmount}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-right mt-2">
              <strong id="lblPhone">Phone</strong><!--Phone-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <!-- <input type="text" class="form-control" name="Phone" [(ngModel)]="MobileNo" autocomplete="off" id="Phone"
                disabled /> -->

              <span>{{MobileNo}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-right mt-2">
              <strong id="lblEmail">E-mail</strong><!--E-mail-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <!-- <input type="text" class="form-control" name="Email" [(ngModel)]="UserEmail" autocomplete="off" id="Email"
                disabled /> -->

              <span>{{UserEmail}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 text-right mt-2">
              <strong id="lblPaymentType">Payment Type</strong><!--Payment Type-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <!-- <input type="text" class="form-control" name="PaymentType" autocomplete="off" id="PaymentType"
                value="Online" disabled /> -->

              <span>Online</span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-7 mt-1 ml-3">
              <button type="button" class="btn btn-success btn-block btn-lg btn-square"
                (click)="isbooknow = false; CheckAvailability()">
                Re-check availability
              </button>
            </div>
          </div>


          <div class="row d-none" *ngIf="tableitem[0]['ClassID'] == 8 || tableitem[0]['ClassID'] == 9">
            <div class="col-md-4 text-right mt-2">
              <strong id="lblfullroom"><input type="checkbox" class="custom-checkbox1" name="fullroom"
                  [(ngModel)]="itemToEditBooking.IsRoomBook" id="fullroom" /></strong><!--Book Room or not-->
            </div>
            <div class="col-md-5 mt-2 text-left">
              <strong>Want to book full room</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="alert alert-info fontsizeandfamilyCalibri">
        <div class="text-center ml-4 changeColor">
          <a><strong style="font-size:xx-large"> You have selected admission date from
              {{checkinDate | date:'dd-MMM-yyyy'}} to {{checkoutDate | date:'dd-MMM-yyyy'}}</strong></a>
        </div>
      </div>
      <div class="alert alert-dismissible alert-warning text-left">

        <a><i class="fa fa-check"></i><strong> Please note that admissions are not done on sundays.</strong></a><br>
        <a><i class="fa fa-check"></i><b> Please read the rules and regulations by
            visiting our website: www.nisargopcharashram.org before submitting
            this application.</b></a>
        <br />
        <a><i class="fa fa-check"></i><b> The booking amount shall be forfeited if
            the patient/guest fails to check-in by the booking date or fails to
            provide any prior intimation of his/her absence.</b>
        </a><br>
        <a>Please read the
          <a class="btn btn-sm text-white btn-success" (click)="GetRateChart(contentTariff)">Rates,
            Deposits and Charges</a>
          details for your stay at Nisargopchar Ashram, with effect from
          01-April-2024.</a>

      </div>

      <!-- <div class="alert mt-3 alert-info justify-content fontsizeandfamilyCalibri">
    <div class="text-left ml-2 mr-2">
      <a class="text-justify">After making the booking, you can always cancel and re-book for later date of your
        convenience and availability of
        accommodation of your choice,<strong>before the date of confirm booking</strong></a>
      <a>You can always <a class="btn btn-warning btn-sm">contact us</a> for more clarifications.
      </a>
    </div>
  </div> -->
      <!-- <div class="alert mt-3 alert-info text-left fontsizeandfamilyCalibri">

      </div> -->

      <!-- <div class="d-flex justify-content-center align-items-center text-center">
        <div class="sec-title">
          <div class="alert alert-info fontsizeandfamilyCalibri">
            <span style="font-family: sans-serif; font-size: 1.3em;">Online Booking Protocol</span>
          </div>
        </div>
      </div> -->
      <div class="alert alert-info fontsizeandfamilyCalibri" style="margin-bottom: 0px;">
        <div class="text-center">
          <span style="font-family: sans-serif; font-size: 1.3em; color:#0d232e;">Online Booking Protocol</span>
        </div>
      </div>

      <div class="row justify-content-center" *ngIf="ProtocolRegulation && ProtocolRegulation.length > 0">
        <div class="row alert alert-info" style="max-height: 200px; overflow-y: auto; max-width: 98%; color:#0d232e">
          <!-- (scroll)="onScroll($event)" -->
          <div class="col-lg-6">
            <ul class="consent-list">
              <ng-container *ngFor="let item of ProtocolRegulation; let i = index">
                <li *ngIf="i < ProtocolRegulation.length - 1 && i % 2 === 0" class="fontsizeandfamilyCalibri">
                  <div class="card-body p-2">
                    <strong class="card-text" [innerHTML]="item.RegulationDescriptionEnglish"></strong>
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>

          <div class="col-lg-6">
            <ul class="consent-list">
              <ng-container *ngFor="let item of ProtocolRegulation; let i = index">
                <li *ngIf="i < ProtocolRegulation.length - 1 && i % 2 === 1" class="fontsizeandfamilyCalibri">
                  <div class="card-body p-2">
                    <strong class="card-text" [innerHTML]="item.RegulationDescriptionEnglish"></strong>
                  </div>
                </li>
              </ng-container>
            </ul>
          </div>
        </div>


        <div class="col-12 mt-1">
          <div class="accept-checkbox text-center pt-2 pb-2 border-top shadow-sm rounded"
            style="font-size: 1.1rem; background-color: #fff8dc;">
            <label for="acceptAll" class="form-check-label fontsizeandfamilyCalibri align-items-center ml-4">
              <strong>
                <input type="checkbox" class="form-check-input custom-checkbox2 me-2" id="acceptAll"
                  [(ngModel)]="isChecked" style="transform: scale(1.9); margin-right: 12px; border: black;" />
                <!-- [disabled]="!hasScrolledToEnd && !globals.isChecked" -->
              </strong>
              <strong class="ml-2" style="color: #11297e;" [innerHTML]="
                    ProtocolRegulation[ProtocolRegulation.length - 1]
                      ?.RegulationDescriptionEnglish
                  "></strong>
            </label>
          </div>
        </div>
      </div>

      <div *ngIf="GuestQuetionaridetails[0]['Nationality'] == 'Indian'">
        <!-- <div class="d-none row mt-2 d-flex justify-content-end fontsizeandfamilyCalibri">
          <div class="row ml-2">
            <div class="col-md-5 text-left mt-2">
              <strong id="lblPayment">Payment Service Provider</strong>
            </div>
            <div class="col-md-7 mt-2">
              <input type="" class="form-control mr-1 mt-1" name="Payment" autocomplete="off" id="Payment"
                [(ngModel)]="PaymentServiceProvider" placeholder="Payment Service Provider" disabled />
            </div>
          </div>
        </div> -->


        <h2 class="mt-1" style="color: #f9001c">If your payment was successful but the booking is not yet visible,
          please wait a few
          moments. If the issue persists, contact the Nisargopachar team. Please do not attempt to
          book again.</h2>

        <!-- <div *ngIf="PreviousBalancewithBookingID.length > 0"
          class="row d-flex justify-content-center align-items-center fontsizeandfamilySans bg-success">
          <strong>
            Your Previous Balance amount is
            {{ PreviousBalancewithBookingID[0]["BalanceAmount"] }}
          </strong>
        </div> -->

        <div class="row mt-2 d-flex justify-content-end fontsizeandfamilyCalibri">
          <button *ngIf="PreviousBalancewithBookingID.length > 0" type="button" style="background-color: #fff8dc;"
            class="mt-2 mr-4">
            <strong class="ml-1 mr-1 changeColor1">Your Previous Balance amount is rupee
              {{ PreviousBalancewithBookingID[0]["BalanceAmount"] }}</strong>
          </button>

          <button class="btn btn-success fa-sm mr-1 mt-1" [disabled]="!isChecked || IsPaymentScreen"
            (click)="IsReSchedule ? GetRazorpay() : CancellationandModificationPolicy(contentCancellationPolicy)">
            <i [ngClass]="IsPaymentScreen ? 'spinner-border spinner-border-sm mr-1' : ''"></i>
            {{IsReSchedule ? 'Update Schedule' : 'Make Payment'}}

          </button>
        </div>
      </div>

      <div *ngIf="GuestQuetionaridetails[0]['Nationality'] != 'Indian'">
        <div class="row mt-2 d-flex justify-content-end fontsizeandfamilyCalibri">
          <!-- <i class="fas fa-envelope"></i> -->
          <!-- <i class="fas fa-paper-plane"></i>
        <i class="fas fa-share-square"></i> -->
          <button class="btn btn-success fa-sm mr-1 mt-1" [disabled]="!isChecked || isInProgressMail"
            (click)="SendForeignerMail()">
            <i [ngClass]="isInProgressMail ? 'spinner-border spinner-border-sm mr-1' : 'fas fa-envelope mr-1'"></i> Send
            Email
          </button>
        </div>
      </div>

      <!-- <hr />
      <div class="row fontsizeandfamilyCalibri">
        <div class="col-lg ml-1">
          <input type="" class="form-control no-border bg-light" name="Accomodation" autocomplete="off"
            id="Accomodation" style="font-size: 1em" [(ngModel)]="selectedAliesName" disabled />
        </div>
      </div>
      <div class="table-container fontsizeandfamilyCalibri">
        <table class="table table-striped table-hover">
          <thead>
            <tr style="background-color: #77c5ec">
              <th *ngFor="let item of headers">
                <h3>{{ item }}</h3>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of tableitem; let i = index" style="background-color: #e3ebdc">
              <td *ngFor="let key of headers" class="text-center">
                <p>{{ item[key] }}</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row mt-3"></div> -->
    </div>

    <!-- Make Final payment screen -->
    <div class="container mt-5" style="width: 70%;" *ngIf="isFinalPayment && !globals.IsUserDetailsUpdate">
      <div *ngIf="PreviousBalancewithBookingID.length > 0"
        class="row d-flex justify-content-center align-items-center fontsizeandfamilySans bg-success">
        <strong>
          Your Previous Balance amount is
          {{ PreviousBalancewithBookingID[0]["BalanceAmount"] }}
        </strong>
      </div>
      <div class="row fontsizeandfamilyCalibri">
        <div class="col-lg">
          <div class="grid-b-space">
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblGuestName">Guest Name</strong><!--Guest Name-->
              </div>
              <div class="col-md-5 mt-2 text-left">
                <label>{{ GuestName }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblAccomodation">Accomodation</strong><!--Accomodation-->
              </div>
              <div class="col-md-5 mt-2 text-left">
                <label>{{ selectedAliesName }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblPaymentType">Payment Type</strong><!--Payment Type-->
              </div>
              <div class="col-md-5 mt-2 text-left">
                <label>Booking Advance</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5 text-right mt-2">
                <strong id="lblPaymentType">Product Info.</strong><!--Payment Type-->
              </div>
              <div class="col-md-5 mt-2 text-left">
                <label>Booking Advance</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg">
          <div class="row">
            <div class="col-md-5 text-right mt-2">
              <strong id="lblPaymentDate">Payment Date/Time</strong><!--Payment Date/Time-->
            </div>
            <div class="col-md-5 mt-2 text-left">
              <label>{{ Today | date : "dd-MM-yyyy" }}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 text-right mt-2">
              <strong id="lblAmount">Amount (Rs.)</strong><!--Amount (Rs.)-->
            </div>
            <div class="col-md-5 mt-2 text-left">
              <label>{{ TotalAmount }}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 text-right mt-2">
              <strong id="lblPhone">Phone</strong><!--Phone-->
            </div>
            <div class="col-md-5 mt-2 text-left">
              <label>{{ MobileNo }}</label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-5 text-right mt-2">
              <strong id="lblEmail">E-mail</strong><!--E-mail-->
            </div>
            <div class="col-md-5 mt-2 text-left">
              <label>{{ UserEmail }}</label>
            </div>
          </div>
        </div>

        <div class="col-lg">
          <!-- <div class="row">
          <div class="col-md-5 text-right mt-2">
            <strong id="lblPatientSource">Patient Source</strong>
          </div>
          <div class="col-md-5 mt-2 text-left">
            <input type="text" name="PatientSource" id="PatientSource" class="form-control"
              [(ngModel)]="itemToEditBooking.PatientSource" placeholder="Patient Source" />
          </div>
        </div> -->
          <div class="row">
            <div class="col-md-5 text-right mt-2">
              <strong id="lblExpectedArival">Expected Arival</strong><!--Expected Arival-->
            </div>
            <div class="col-md-5 mt-2 text-left">
              <div class="input-group">
                <input class="form-control" matInput name="ExpectedArival" [ngxMatDatetimePicker]="ExpectedArivalTime"
                  [(ngModel)]="itemToEditBooking.ExpectedArival" [min]="checkinDate" />
                <span class="input-group-append">
                  <mat-datepicker-toggle matSuffix [for]="ExpectedArivalTime"></mat-datepicker-toggle>
                  <ngx-mat-datetime-picker #ExpectedArivalTime>
                  </ngx-mat-datetime-picker>
                </span>
              </div>
            </div>
          </div>
          <!-- <div class="row">
          <div class="col-md-5 text-right mt-2">
            <strong id="lblPhone">Patient Source Location</strong>
          </div>
          <div class="col-md-5 mt-2 text-left">
            <input type="text" name="PatientSourceLocation" id="PatientSourceLocation" class="form-control"
              [(ngModel)]="itemToEditBooking.PatientSourceLocation" placeholder="Patient Source Location" />
          </div>
        </div> -->
        </div>
      </div>
      <!-- <div class="alert alert-dismissible alert-warning fontsizeandfamilyCalibri">
        <div class="text-left ml-4">
          <a><i class="fa fa-check"></i> Please read the rules and regulations by
            visiting our website: www.nisargopcharashram.org before submitting
            this application.</a>
          <br />
          <a><i class="fa fa-check"></i> The booking amount shall be forfeited if
            the patient/guest fails to check-in by the booking date or fails to
            provide any prior intimation of his/her absence.
          </a>
        </div>
      </div> -->
      <!-- <div class="alert mt-3 alert-info text-left fontsizeandfamilyCalibri">
        <a>Please read the
          <a class="btn btn-sm text-white" style="background-color: #fd7f33"
            (click)="GetRateChart(contentTariff)">Rates,
            Deposits and Charges</a>
          details for your stay at Nisargopchar Ashram, with effect from
          01-April-2024.</a>
      </div> -->
      <h2 class="text-danger">If your payment was successful but the booking is not yet visible, please wait a few
        moments. If the issue persists, contact the Nisargopachar team. <br>Please do not attempt to
        book again.</h2>
      <div class="d-flex justify-content-between mt-2 fontsizeandfamilyCalibri">
        <button class="btn btn-danger fa-sm ml-5 mt-1" (click)="MakePayment('Cancel')">
          Cancel Payment
        </button>
        <button id="MakeFinalPayment" class="btn btn-success fa-sm mr-5 mt-1 mr-2"
          [disabled]="this.itemToEditBooking.ThirdpartyPaymentID != '' || IsPayment" (click)="GetRazorpay()">
          <i [ngClass]="
            IsPayment
              ? 'spinner-border spinner-border-sm mr-1'
              : 'fa-lg fa fa-money'
          "></i>
          Make Payment
        </button>
      </div>
    </div>
  </div>



  <!-- Add/Edit Guest Popup -->
  <ng-template #content let-caa="close('a')">
    <div class="bg-white px-4 py-4 shadow-box rounded">
      <form name="EditClient" class="container-fluid" #f="ngForm" novalidate>
        <div class="">
          <div class="container" *ngIf="!TransferConfirmation">
            <div class="d-flex justify-content-center mb-1">
              <img class="newLogo" src="/assets/img/New Logo - Transperent.png" width="80" height="80" alt="" />
            </div>
            <h3 class="text-center responsive-text mb-2" style="color: #026d64">
              Welcome to Nisargopchar Ashram
            </h3>
            <div class="row mt-2 d-flex justify-content-center align-items-center text-center">
              <div class="col-12">
                <h1 style="font-family: sans-serif; font-size: 1.5rem">
                  {{
                  +itemToEdit.OnlinePatientRegistrationID == 0
                  ? "Add Guest details"
                  : "Edit Guest details"
                  }}
                </h1>
              </div>
              <div class="col-12">
                <!-- <h6 class="form-control1" *ngIf="itemToEdit.OnlinePatientRegistrationID == 0"
                  style="font-family: sans-serif; color: #ff0000;font-size: 20px;">
                  Please ensure your personal details are entered accurately. Once the form is submitted, changes will
                  not be permitted.
                </h6>
                <h6 class="form-control1" *ngIf="itemToEdit.OnlinePatientRegistrationID != 0"
                  style="font-family: sans-serif; color: #ff0000;font-size: 20px;">
                  Editing is disabled. The information is available for viewing only. If you need to make any changes,
                  please contact the Nisargopachar team.
                </h6> -->
              </div>
            </div>
            <div class="row grid-b">
              <div class="col-lg">
                <!-----  Prefix ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblPrefix">Prefix </strong>
                  <select class="form-select form-control" name="Prefix" id="Prefix" title="Select Prefix"
                    [(ngModel)]="itemToEdit.Prefix" [disabled]="itemToEdit.OnlinePatientRegistrationID != 0">
                    <option disabled value="">Select Prefix</option>
                    <option *ngFor="let prefix of Prefix" [value]="prefix.Description">
                      {{ prefix.Description }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg">
                <!-----  First Name ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblFirstName">First Name <span style="color: red">*</span></strong>
                  <input type="text" name="FirstName" id="FirstName" class="form-control" (input)="
                      UpperCase(itemToEdit.FirstName, 'FirstName');
                      TrimName(itemToEdit.FirstName, 'FirstName')
                    " [(ngModel)]="itemToEdit.FirstName" autocomplete="off"
                    [disabled]="itemToEdit.OnlinePatientRegistrationID != 0" />
                </div>
              </div>
              <div class="col-lg-3 d-none">
                <!-----  Middle Name ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblMiddleName">Middle Name </strong>
                  <input type="text" name="MiddleName" id="MiddleName" class="form-control" (input)="
                      UpperCase(itemToEdit.MiddleName, 'MiddleName');
                      TrimName(itemToEdit.MiddleName, 'MiddleName')
                    " [(ngModel)]="itemToEdit.MiddleName" autocomplete="off"
                    [disabled]="itemToEdit.OnlinePatientRegistrationID != 0" />
                </div>
              </div>
              <div class="col-lg">
                <!-----  Last Name ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblLastName">Last Name <span style="color: red">*</span></strong>
                  <input type="text" name="LastName" id="LastName" class="form-control" (input)="
                      UpperCase(itemToEdit.LastName, 'LastName');
                      TrimName(itemToEdit.LastName, 'LastName')
                    " [(ngModel)]="itemToEdit.LastName" autocomplete="off"
                    [disabled]="itemToEdit.OnlinePatientRegistrationID != 0" />
                </div>
              </div>
            </div>
            <div class="row grid-b">
              <div class="col-lg">
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <!--Date Of Birth-->
                  <strong id="DateOfBirth">Date Of Birth <span style="color: red">*</span></strong>
                  <div class="input-group">
                    <input class="form-control" matInput name="DateOfBirth" [matDatepicker]="DateOfBirth" [max]="Today"
                      [(ngModel)]="itemToEdit.DateOfBirth" disabled
                      (dateChange)="calculateAge(itemToEdit.DateOfBirth, Today)" />
                    <span class="input-group-append">
                      <mat-datepicker-toggle matSuffix [for]="DateOfBirth"></mat-datepicker-toggle>
                      <mat-datepicker #DateOfBirth
                        [disabled]="itemToEdit.OnlinePatientRegistrationID != 0 && itemToEdit.DateOfBirth != defaultDOB"></mat-datepicker>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-lg">
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <!----- Age ------>
                  <strong id="lblAge">Age </strong>
                  <input type="text" name="Age" id="Age" class="form-control" [(ngModel)]="itemToEdit.Age" disabled
                    placeholder="Age" />
                </div>
              </div>
              <div class="col-lg">
                <!----- Gender ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblGender">Gender <span style="color: red">*</span></strong>
                  <select class="form-select form-control" name="Gender" id="Gender" title="Select Gender"
                    [(ngModel)]="itemToEdit.Gender"
                    [disabled]="itemToEdit.OnlinePatientRegistrationID != 0 && itemToEdit.Gender != ''">
                    <option disabled value="">Select Gender</option>
                    <option *ngFor="let gender of genders" [value]="gender.value">
                      {{ gender.description }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-3 d-none">
                <!----- RelationWithUser ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblRelationWithUser">Relation With User</strong>
                  <input type="text" name="RelationWithUser" id="RelationWithUser" class="form-control"
                    [(ngModel)]="itemToEdit.RelationWithUser" (keypress)="validateService.alphabetOnly($event)" />
                </div>
              </div>
              <div class="col-lg">
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblGSM1"> Mobile Number <span style="color: red">*</span></strong>
                  <div class="input-group">
                    <input type="text" name="RegGSM" id="RegGSM" class="form-control" [(ngModel)]="itemToEdit.GSM"
                      maxlength="10" (keypress)="validateService.numberOnly($event)"
                      [disabled]="itemToEdit.OnlinePatientRegistrationID != 0" required />
                    <div class="input-group-append">
                      <!--Whatsapp connected-->
                      <span class="input-group-text password-toggle"
                        (click)="itemToEdit.OnlinePatientRegistrationID != 0 ? null : GetGSMasWAGSM(isUserWAGSM, 'Guest')">
                        <i class="fa fa-whatsapp" style="color: green" title="WhatsApp Connected?"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg fontsizeandfamilyCalibri">
                <div class="form-group text-left">
                  <strong id="lblWAGSM">WhatsApp Mobile Number</strong>
                  <!-- (click)="GetSelectedRowOpIpID(item.OpIpID,$event.target.checked);" -->
                  <input type="text" name="WAGSM" id="WAGSM" class="form-control"
                    [disabled]="itemToEdit.OnlinePatientRegistrationID != 0"
                    (keypress)="validateService.numberOnly($event)" maxlength="10" [(ngModel)]="itemToEdit.WAGSM"
                    required />
                </div>
              </div>
              <div class="col-lg fontsizeandfamilyCalibri d-none">
                <!----- Preferred Language ------>
                <div class="form-group text-left">
                  <strong id="lblPreferredLanguage">Preferred Language</strong>
                  <select class="form-select form-control" name="PreferredLanguage" id="PreferredLanguage"
                    title="Select Preferred Language" [(ngModel)]="itemToEdit.PreferredLanguage">
                    <option disabled value="">Select Preferred Language</option>
                    <option *ngFor="let lang of LanguageType" [value]="lang.Description">
                      {{ lang.Description }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg fontsizeandfamilyCalibri">
                <div class="form-group text-left">
                  <!-- <strong id='lblUserEmail'>{{IsUserEmailSend ? 'OTP' : 'Email'}} <span style="color: red;">*</span>
                </strong> -->
                  <strong id="lblUserEmail">Email <span style="color: red">*</span></strong>
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="Email Address" id="email" name="email"
                      [disabled]="itemToEdit.OnlinePatientRegistrationID != 0" [(ngModel)]="itemToEdit.GuestEmail"
                      (input)="validateService.validateEmail($event)" required email />
                    <!-- <div class="input-group-appent">
                    <button type="button" id="SendGuestOTP" class="btn btn-md btnpadding bg-primary ml-2"
                      [disabled]="itemToEdit.GuestEmail == ''" *ngIf="!IsEmailVerified"
                      (click)="VerifyUserEmail('GuestVerify');">
                      <i [ngClass]="isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''"></i>
                      Send OTP</button>
                    <div *ngIf="IsEmailVerified" class="text-success font-weight-bold">
                      <i class="fas fa-check-circle"></i>
                    </div>
                  </div> -->
                  </div>
                  <!-- <div class="input-group" *ngIf="IsUserEmailSend">
                  <input type="text" class="form-control" placeholder="OTP" id="GuestOTP" name="GuestOTP"
                    [(ngModel)]="GuestOTP" (keypress)='validateService.numberOnly($event)' required email>
                  <div class="input-group-appent">
                    <button type="button" id="VerifyGuestOTP" class="btn btn-md btnpadding bg-primary ml-2"
                      [disabled]="GuestOTP.length < 4"
                      (click)="VerifyOTP(itemToEdit.GuestEmail,GuestOTP, 'GuestVerify');">
                      Verify OTP</button>
                  </div>
                </div> -->
                </div>
              </div>
            </div>
            <div class="row grid-b">
              <div class="col-lg fontsizeandfamilyCalibri d-none">
                <div class="form-group text-left">
                  <!----- Address ------>
                  <strong id="lblAddress">Address <span style="color: red">*</span></strong>
                  <textarea type="text" name="Address" id="Address" class="form-control"
                    [(ngModel)]="itemToEdit.Address" placeholder="Address"></textarea>
                </div>
              </div>
              <div class="col-lg fontsizeandfamilyCalibri">
                <div class="form-group text-left">
                  <!----- Country ------>
                  <strong id="lblAddress">Country <span style="color: red">*</span></strong>
                  <input type="text" name="Country" id="Country" class="form-control" [matAutocomplete]="auto"
                    [(ngModel)]="itemToEdit.Country" placeholder="Country" />
                </div>
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option *ngFor="
                      let City of CountryandNationality
                        | filter : itemToEdit.Country
                    " [value]="City['Country']" title="{{ City['Country'] }}">
                    {{ City["Country"] }}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg fontsizeandfamilyCalibri">
                <div class="form-group text-left">
                  <!----- State ------>
                  <strong id="lblState">State</strong>
                  <input type="text" name="State" id="State" class="form-control" [matAutocomplete]="autoState"
                    [(ngModel)]="itemToEdit.State" placeholder="State" />
                </div>
                <mat-autocomplete #autoState="matAutocomplete">
                  <mat-option *ngFor="
                      let state of States | filter : itemToEdit.State;
                      trackBy: trackByFn
                    " (onSelectionChange)="GetDistrictList($event);GetCityList($event.source.value, 'Guest');"
                    [value]="state['State']" title="{{ state['State'] }}">
                    {{ state["State"] }}
                  </mat-option>
                </mat-autocomplete>
              </div>

              <div class="col-lg fontsizeandfamilyCalibri d-none">
                <div class="form-group text-left">
                  <!----- District  [disabled]="itemToEdit.BookingID !=0" ------>
                  <strong id="lblDistrict">District</strong>
                  <input type="text" name="District" id="District" class="form-control"
                    [matAutocomplete]="autoDistrict1" [(ngModel)]="itemToEdit.District" placeholder="District" />
                </div>
                <mat-autocomplete #autoDistrict1="matAutocomplete">
                  <mat-option *ngFor="
                      let cc of District | filter : itemToEdit.District;
                      trackBy: trackByFn
                    " (onSelectionChange)="
                      GetDistrictList($event); GetCityList($event.source.value, 'Guest')
                    " [value]="cc['District']" title="{{ cc['District'] }}">
                    {{ cc["District"] }}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg fontsizeandfamilyCalibri">
                <div class="form-group text-left">
                  <!----- City ------>
                  <strong id="lblCity">City</strong>
                  <input type="text" name="City" id="City" class="form-control" [matAutocomplete]="autoCity"
                    [(ngModel)]="itemToEdit.City" placeholder="City" />
                </div>
                <mat-autocomplete #autoCity="matAutocomplete">
                  <mat-option *ngFor="
                      let aa of City | filter : itemToEdit.City;
                      trackBy: trackByFn
                    " [value]="aa['City']" title="{{ aa['City'] }}">
                    {{ aa["City"] }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="row grid-b">
              <div class="col-lg-4">
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <!----- Nationality ------>
                  <strong id="lblNationality">Nationality <span style="color: red">*</span></strong>
                  <input type="text" name="Nationality" id="Nationality" class="form-control"
                    [matAutocomplete]="autoNationality" [(ngModel)]="itemToEdit.Nationality"
                    placeholder="Nationality" />
                </div>
                <mat-autocomplete #autoNationality="matAutocomplete" (optionSelected)="SetMandatoryAadharandPassport()">
                  <mat-option *ngFor="
                      let Nation of CountryandNationality
                        | filter : itemToEdit.Nationality
                    " [value]="Nation['Nationality']" title="{{ Nation['Nationality'] }}">
                    {{ Nation["Nationality"] }}
                  </mat-option>
                </mat-autocomplete>
              </div>
              <div class="col-lg-4" *ngIf="itemToEdit.Nationality == 'Indian'">
                <!----- Aadhar No ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblAadharNo">Aadhar No.</strong>
                  <input type="text" name="AadharNo" id="AadharNo" class="form-control"
                    [disabled]="itemToEdit.OnlinePatientRegistrationID != 0 && itemToEdit.AadharNo.length == 12"
                    [(ngModel)]="itemToEdit.AadharNo" (keypress)="validateService.numberOnly($event)"
                    (input)="ValidateAadhaar(itemToEdit.AadharNo);clearFieldError('GuestAadhar');"
                    placeholder="Aadhar No" maxlength="12" />
                </div>
                <small *ngIf="!isValidAadhaar" class="text-danger fontsizeandfamilyCalibri">
                  Invalid Aadhaar Number. please enter valid Aadhaar Number.
                </small>
                <small *ngIf="fieldErrors['GuestAadhar']" class="text-danger">
                  {{ fieldErrors['GuestAadhar'] }}
                </small>
              </div>
              <div class="col-lg-4" *ngIf="itemToEdit.Nationality != 'Indian' && itemToEdit.Nationality != ''">
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <!----- Passport No ------>
                  <strong id="lblPassportNo">Passport No. </strong>
                  <input type="text" name="PassportNo" id="PassportNo" class="form-control"
                    (input)="validatePassport(itemToEdit.PassportNo)" [(ngModel)]="itemToEdit.PassportNo"
                    placeholder="Passport No" maxlength="12" />
                </div>
                <small *ngIf="!isValidPassport" class="text-danger">
                  Invalid Passport Number. please enter valid Passport Number.
                </small>
              </div>
              <div class="col-lg-4" *ngIf="itemToEdit.Nationality != 'Indian' && itemToEdit.Nationality != ''">
                <!----- VisaNo ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblVisaNo">Visa No</strong>
                  <input type="text" name="VisaNo" id="VisaNo" class="form-control" [(ngModel)]="itemToEdit.VisaNo"
                    (keypress)="validateService.validateOnlyNumberAndAlphabets($event)" maxlength="10" />
                </div>
              </div>
              <div class="col-lg-4" *ngIf="itemToEdit.Nationality != 'Indian' && itemToEdit.Nationality != ''">
                <!----- OCINo ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblOCINo">OCI No</strong>
                  <input type="text" name="OCINo" id="OCINo" class="form-control" [(ngModel)]="itemToEdit.OCINo"
                    (keypress)="validateService.validateOnlyNumberAndAlphabets($event)" maxlength="10" />
                </div>
              </div>
              <div class="col-lg d-none">
                <!----- Pincode ------>
                <div class="form-group text-left fontsizeandfamilyCalibri">
                  <strong id="lblPincode">Pincode</strong>
                  <input type="text" name="Pincode" id="Pincode" class="form-control" [(ngModel)]="itemToEdit.PinCode"
                    (keypress)="validateService.numberOnly($event)" maxlength="7" />
                </div>
              </div>
            </div>
            <div class="d-flex">
              <button type="button" id="btnClose" class="btn btn-md bg-primary mr-3" (click)="(caa)">
                <i class="fa fa-times mr-1" aria-hidden="true"></i>
                Close
              </button>
              <!----- Pop Up Close ------>
              <button type="button" id="SaveGuest" [disabled]="f.form.pristine" class="btn btn-md bg-primary"
                (click)="SaveGuest()">
                <i [ngClass]="
                    isInProgressGuest
                      ? 'spinner-border spinner-border-sm mr-1'
                      : 'fa fa-save mr-1'
                  "></i>
                Save
              </button>
              <!----- Save Data ------>
            </div>
          </div>

          <div class="container mt-3" *ngIf="TransferConfirmation">
            <div class="shadow p-4 rounded-4 text-center">
              <!-- <h5 class="fontsizeandfamilyCalibri mb-3">Verify Mobile Number</h5> -->
              <h5 class="fontsizeandfamilyCalibri mb-3">Verify Email</h5>
              <!-- <p class="fontsizeandfamilyCalibri mb-4">
              We've sent an OTP to your registered mobile number:
              <strong>{{ maskedMobileNumber }}</strong>
            </p> -->
              <p class="fontsizeandfamilyCalibri mb-4">
                We've sent an OTP to your registered Email:
                <strong>{{ maskedEmail }}</strong>
                and your registered mobile number:
                <strong>{{ maskedMobileNumber }}</strong>
              </p>
              <div class="d-flex justify-content-center align-items-center">
                <div class="col-md-3 fontsizeandfamilyCalibri mb-3">
                  <input type="text" class="form-control text-center" maxlength="4" placeholder="Enter OTP"
                    id="GuestOTP" name="GuestOTP" [(ngModel)]="GuestOTP" [disabled]="!IsUserEmailSend"
                    (keypress)="validateService.numberOnly($event)" />
                </div>
              </div>

              <button class="btn btn-primary" (click)="VerifyUserEmail('GuestVerify')" *ngIf="!IsUserEmailSend">
                <i [ngClass]="
                    isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''
                  "></i>
                Send OTP
              </button>
              <button class="btn btn-primary" (click)="VerifyOTP(TransferGuestEmail, GuestOTP, 'GuestVerify')"
                *ngIf="IsUserEmailSend">
                Verify OTP
              </button>
              <button type="button" id="btnClose" class="btn btn-md bg-primary mr-3"
                (click)="TransferConfirmation = false">
                <i class="fa fa-times mr-1" aria-hidden="true"></i>
                Close
              </button>
              <!----- Pop Up Close ------>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ng-template>

  <!---Booking Questionnaire List-->
  <div class="container ttm-bgcolor-whiteecolor" style="width: 70%;"
    *ngIf="isBookingQuetionary && !globals.IsUserDetailsUpdate">
    <div class="row mt-3 fontsizeandfamilyCalibri">
      <div class="col-auto">
        <button type="button" class="btn btn-square bg-dark" style="color: #ffffff" title="Click to go back" *ngIf="(
          ((!isMainScreen && !isRegistration && !issignin) ||
          isBookingQuetionary ||
          isBookingHistory ||
          globals.isPaymentHistory ||
          isregister ||
          isbooknow) &&
          !isFinalPayment) ||
          IsUserDetailsType == 'click' ||
          (BookingHistory.length > 0 && IsPatientHistorySheet)" (click)="GetBack()">
          <i class="fa fa-lg fa-arrow-left" aria-hidden="true"></i> Back
        </button>
      </div>
      <div class="col-lg">
        <div class="grid-b-space">
          <div class="row">
            <div class="col-md-3 text-right mt-2">
              <label id="lblGuestName">Guest Name</label><!--Guest Name-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{ GuestName }}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-right mt-2">
              <label id="lblExpectedcheckin">Date of birth</label>
              <!--Expected check-in-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{
                GuestQuetionaridetails[0].DateOfBirth | date : "dd-MMM-yyyy"
                }}</strong>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 text-right mt-2">
              <label id="lblNoofdays">Sex</label><!----No. of days---->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{ GuestQuetionaridetails[0].Gender }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg">
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblAccomodation">Address</label><!--Accomodation-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{ GuestQuetionaridetails[0].City }}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblEmail">E-mail</label><!--E-mail-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{ GuestQuetionaridetails[0].Email }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <div class="unseen">
        <table class="table table-striped table-hover text-left fontsizeandfamilyCalibri">
          <thead>
            <tr class="alert alert-dismissible alert-info" style="background-color: #77c5ec">
              <th style="min-width: 20px !important; max-width: 20px !important"></th>
              <th>
                <h2>Medical History & Current Health Status</h2>
                Please answer the following questions (All questions are
                mandatory)
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of Questionnaire; let i = index" style="background-color: #e3ebdc">
              <td style="min-width: 20px !important; max-width: 20px !important">
                {{ 10 * (page - 1) + i + 1 }}
              </td>
              <td>{{ item.Question }}</td>
              <td>
                <div class="btn-group btn-group-toggle">
                  <label class="btn" style="background-color: #fd7f33">
                    <!-- <input type="radio" name="Answer1" id="Answer1" value="Yes" autocomplete="off"> -->
                    <input name="options4{{ i }}" ng-control="options4" type="radio" [value]="'true'"
                      [disabled]="isDisabled" [(ngModel)]="item.SelectedAnswer" />
                    Yes
                  </label>
                  <label class="btn" style="background-color: #77c5ec">
                    <!-- <input type="radio" name="Answer1" id="Answer1" value="No" autocomplete="off"> -->
                    <input name="options4{{ i }}" ng-control="options4" type="radio" [value]="'false'"
                      [disabled]="isDisabled" [(ngModel)]="item.SelectedAnswer" />
                    No
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- <hr /> -->
    <div class="row mt-1 d-flex justify-content-center fontsizeandfamilyCalibri">
      <button type="button" name="submitButton" id="submitButton" class="btn btn-li btn-square text-white"
        *ngIf="!isDisabled" (click)="saveQuestionnaireEligibility(contentDocument)" [disabled]="isInProgress">
        <i [ngClass]="
            isInProgress
              ? 'spinner-border spinner-border-sm mr-1'
              : 'fa fa-save mr-1'
          "></i>
        Submit
      </button>
      <button type="button" name="submitButton" id="submitButton" class="btn btn-li btn-square text-white ml-2"
        *ngIf="!IsHoldPatient && isDisabled" (click)="AttachDocument(contentDocument,0)">
        <i class="fa fa-paperclip mr-1" aria-hidden="true"></i> Upload Medical Report
      </button>
    </div>
  </div>

  <!-- Show Tariff Chart -->
  <!-- <ng-template #contentTariff let-ct="close('a')">
    <div class="BackgroundImage bg-white p-5 rounded shadow-lg">
      <form name="EditClient" class="container-fluid h-100 w-100 overflow-auto" #f="ngForm" novalidate>
        <div class="container">
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h3 class="text-primary mb-0">
              <i class="fa fa-bed mr-2"></i> Accommodation Tariff
            </h3>
            <button type="button" id="btnClose" class="btn btn-outline-danger" (click)="(ct)">
              <i class="fa fa-times mr-1"></i> Close
            </button>
          </div>

          <div class="mb-4">
            <p class="text-muted mb-1 fontsizeandfamilySans">
              <strong>NISARGOPCHAR GRAMSUDHAR TRUST'S</strong>
            </p>
            <p class="text-muted mb-1 fontsizeandfamilyCalibri">
              Nisargopchar Ashram, Uruli Kanchan, Pune
            </p>
            <p class="text-muted fontsizeandfamilyCalibri">
              Effective From: <strong>01-April-2024</strong>
            </p>
            <p class="text-muted" style="font-family: Calibri; font-size: 1.26em">
              <strong>TARIFF</strong>
            </p>
            <span class="ticker-item">
              Please note: Room tariffs will be revised from 15 August 2026. Charges may vary based on your stay dates.
              &nbsp;
              <a href="\assets\img\NCA_Tafiff_15-08-26.jpeg" target="_blank" class="ticker-link">
                ➤ Click here to view updated rates
              </a>
            </span>
          </div>

          <div class="table-responsive mb-4 fontsizeandfamilyCalibri">

            <table class="table table-striped table-bordered">

              <thead class="thead-dark">
                <tr>
                  <th>Category of the Room</th>
                  <th>Room Rent Per Day / Per Person</th>
                  <th>Deposit # for 6 nights / 7 Days</th>
                  <th>Deposit # for 14 nights / 15 Days</th>
                </tr>
              </thead>

              <tbody>

                <tr *ngFor="let room of roomCategories">

                  <td>
                    {{room.CategoryName}}
                    <span *ngIf="room.IsAttachedBath">*</span>
                  </td>

                  <td>
                    ₹{{room.RentPerDay}}
                  </td>

                  <td>
                    ₹{{room.Deposit6Nights}}
                  </td>

                  <td>
                    ₹{{room.Deposit14Nights}}
                  </td>

                </tr>

              </tbody>

            </table>

            <div class="d-flex justify-content-between">

              <p class="text-muted fontsizeandfamilyCalibri">
                * Rooms with attached bath and washroom
              </p>

              <p class="text-muted fontsizeandfamilyCalibri">
                # Deposit towards food and paid services
              </p>

            </div>

          </div>

          <div class="mb-4 fontsizeandfamilyCalibri">
            <h5 class="px-3 py-2 rounded border-left border-primary text-white border-4"
              style="background-color: #414658">
              <i class="fa fa-info-circle text-primary mr-2"></i> Other Charges
            </h5>

            <table>
              <tbody class="text-left">
                <tr>
                  <td>Booking Deposit: <strong>₹2000</strong></td>
                  <td>
                    Admission Fee Registration Charges: <strong>₹750</strong>
                  </td>
                </tr>
                <tr>
                  <td>Consultation Fee on Admission: <strong>₹350</strong></td>
                  <td>
                    Consultation Fee Every Subsequent Check Up/Visit:
                    <strong>₹100</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Consultation Fee O.P.D. (Urban): <strong>₹350</strong>
                  </td>
                  <td>
                    Consultation Fee O.P.D. (Local): <strong>₹150</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="fontsizeandfamilyCalibri">
            <h5 class="px-3 py-2 rounded border-left border-success text-white border-4"
              style="background-color: #414658">
              <i class="fa fa-sticky-note text-success mr-2"></i> Notes
            </h5>
            <ul class="pl-4">
              <p style="color: #282727">
                Room rent includes Hydrotherapy and Mud therapy charges.
              </p>
              <p style="color: #282727">
                Physiotherapy, Neurotherapy, Acupuncture, Massage, Special
                Hydrotherapy, and food are charged separately.
              </p>
              <p style="color: #282727">
                Charges mentioned above are per bed/per day.
              </p>
              <p style="color: #282727">
                Guest charges will be same as that of patient charges.
              </p>
              <p style="color: #282727">
                Patient have to arrange for attendant if recommended by the
                doctor, which is charged 50% of room rent per day.
              </p>
              <p style="color: #282727">
                Except single rooms, all categories of rooms are on sharing
                basis.
              </p>
              <p style="color: #282727">
                Laundry service can be availed at an extra cost.
              </p>
            </ul>
          </div>
        </div>
      </form>
    </div>
  </ng-template> -->

  <ng-template #contentTariff let-ct="close('a')">
    <div class="BackgroundImage bg-white p-5 rounded shadow-lg">
      <form name="EditClient" class="container-fluid h-100 w-100 overflow-auto" #f="ngForm" novalidate>
        <div class="container">
          <!-- ================= HEADER ================= -->
          <div class="d-flex justify-content-between align-items-center mb-4">
            <h3 class="text-primary mb-0">
              <i class="fa fa-bed mr-2"></i>
              Accommodation Tariff
            </h3>
            <button type="button" id="btnClose" class="btn btn-outline-danger" (click)="ct()">
              <i class="fa fa-times mr-1"></i>
              Close
            </button>
          </div>
          <!-- ================= INFO ================= -->
          <div class="mb-4">
            <p class="text-muted mb-1 fontsizeandfamilySans">
              <strong>
                NISARGOPCHAR GRAMSUDHAR TRUST'S
              </strong>
            </p>
            <p class="text-muted mb-1 fontsizeandfamilyCalibri">
              Nisargopchar Ashram, Uruli Kanchan, Pune
            </p>
            <p class="text-muted fontsizeandfamilyCalibri">
              Effective From:
              <strong>
                {{ tariffEffectiveFrom | date:'dd-MMMM-yyyy' }}
              </strong>
            </p>
            <p class="text-muted" style="font-family: Calibri; font-size: 1.26em">
              <strong>TARIFF</strong>
            </p>
          </div>
          <!-- ================================================= -->
          <!-- ROOM RENT TABLE                                   -->
          <!-- ================================================= -->
          <div class="table-responsive mb-4 fontsizeandfamilyCalibri">
            <table class="table table-striped table-bordered">
              <thead class="thead-dark">
                <tr>
                  <th>
                    Category of the Room
                  </th>
                  <th>
                    Room Rent Per Day / Per Person
                  </th>
                  <th>
                    Deposit # for 6 nights / 7 Days
                  </th>
                  <th>
                    Deposit # for 14 nights / 15 Days
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let room of roomCategories">
                  <!-- Room Category -->
                  <td>
                    {{ room.Name }}
                    <span *ngIf="room.IsAttachedBath"> * </span>
                  </td>
                  <!-- Room Rent -->
                  <td>
                    ₹{{ room.Amount }}
                  </td>
                  <!-- Deposit 6 Nights -->
                  <td>
                    ₹{{ room.Deposit6Nights }}
                  </td>
                  <!-- Deposit 14 Nights -->
                  <td>
                    ₹{{ room.Deposit14Nights }}
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- Room Notes -->
            <div class="d-flex justify-content-between">
              <p class="text-muted fontsizeandfamilyCalibri">
                * Rooms with attached bath and washroom
              </p>
              <p class="text-muted fontsizeandfamilyCalibri">
                # Deposit towards food and paid services
              </p>
            </div>
          </div>
          <!-- ================================================= -->
          <!-- OTHER CHARGES                                    -->
          <!-- ================================================= -->
          <div class="mb-4 fontsizeandfamilyCalibri">
            <h5 class="px-3 py-2 rounded border-left border-primary text-white border-4"
              style="background-color: #414658">
              <i class="fa fa-info-circle text-primary mr-2"></i>
              Other Charges
            </h5>
            <table>
              <tbody class="text-left">
                <tr
                  *ngFor="let charge of otherCharges; let i = index">
                  <ng-container *ngIf="i % 2 === 0">
                    <!-- First Charge -->
                    <td>
                      {{ charge.Name }}:
                      <strong>
                        ₹{{ charge.Amount }}
                      </strong>
                    </td>
                    <!-- Second Charge -->
                    <td *ngIf="otherCharges[i + 1]">
                      {{ otherCharges[i + 1].Name }}:
                      <strong>
                        ₹{{ otherCharges[i + 1].Amount }}
                      </strong>
                    </td>
                  </ng-container>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- ================================================= -->
          <!-- NOTES                                             -->
          <!-- ================================================= -->
          <div class="fontsizeandfamilyCalibri">
            <h5 class="px-3 py-2 rounded border-left border-success text-white border-4"
              style="background-color: #414658">
              <i class="fa fa-sticky-note text-success mr-2"></i>
              Notes
            </h5>
            <ul class="pl-4">
              <p style="color: #282727">
                Room rent includes Hydrotherapy and Mud therapy charges.
              </p>
              <p style="color: #282727">
                Physiotherapy, Neurotherapy, Acupuncture, Massage,
                Special Hydrotherapy, and food are charged separately.
              </p>
              <p style="color: #282727">
                Charges mentioned above are per bed/per day.
              </p>
              <p style="color: #282727">
                Guest charges will be same as that of patient charges.
              </p>
              <p style="color: #282727">
                Patient have to arrange for attendant if recommended
                by the doctor, which is charged 50% of room rent per day.
              </p>
              <p style="color: #282727">
                Except single rooms, all categories of rooms are on
                sharing basis.
              </p>
              <p style="color: #282727">
                Laundry service can be availed at an extra cost.
              </p>
            </ul>
          </div>
        </div>
      </form>
    </div>
  </ng-template>

  <!-- Document Attachment -->
  <ng-template #contentDocument let-ctad="close('a')">
    <div class="BackgroundImageDocument bg-white p-1 rounded shadow-lg">
      <form name="EditClient" class="container-fluid h-100 w-100 overflow-auto" #f="ngForm" novalidate>
        <div class="container-fluid">
          <!-- Patient Search -->
          <!-- <div class="col-sm mb-3" *ngIf="C_Name != 'Casepaper'">
          <div class="row">
            <div class="col-lg-4 mx-auto">
              <div class="input-group">
                <input class="form-control" id="Patient_Search" placeholder="Search by Name or GSM or RegNo/UHID"
                  [(ngModel)]="SearchTerm" (keypress)='PatientSmartSearch()' [matAutocomplete]="auto" />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-times" title="Clear List" *ngIf="SearchTerm && C_Name != 'Casepaper'"
                      (click)="PatientSmartSearch();SearchTerm = '';$event.target.value='';"></i>
                  </span>
                </div>
                <mat-autocomplete #auto="matAutocomplete">
                  <mat-option (onSelectionChange)="GetSelectedPatientDetails(item.PatientID);"
                    *ngFor="let item of filteredPatient" [value]="item.PatientName">
                    {{item.RegNo +' ' + item.PatientName + ' ' + item.GSM1 }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
        </div> -->
          <div class="text-center fa-lg font-weight-bold letter-space-1.5" style="line-height: 22px;">Patient {{
            GuestName }} ({{ GuestQuetionaridetails[0]["Age"] + " / " +
            GuestQuetionaridetails[0]["Gender"] }}) your online booking cannot be processed based on your medical
            details.
            Kindly upload your latest medical reports for review. Offline booking will be arranged if approved.
          </div>
          <div class="text-center text-danger fa-lg font-weight-bold mt-2">Patients aged 75–80: 2D Echo + other reports
            (last 6
            months) are mandatory.</div>
          <div class="row mt-2 d-none" style="border: 1px solid; border-radius: 10px">
            <div class="col-lg mt-2">
              <div class="form-group">
                <label style="font-weight: bold">Guest Name</label>
                <br />
                <label style="font-weight: normal; font-size: 13px">{{
                  GuestQuetionaridetails[0]["GuestName"]
                  }}</label>
              </div>
            </div>
            <div class="col-lg mt-2">
              <div class="form-group">
                <label style="font-weight: bold">Age / Gender</label>
                <br />
                <label style="font-weight: normal; font-size: 13px">{{
                  GuestQuetionaridetails[0]["Age"] +
                  " / " +
                  GuestQuetionaridetails[0]["Gender"]
                  }}</label>
              </div>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-lg">
              <div class="row">
                <div class="table-responsive mt-2" *ngIf="items['PatientName'] != ''">
                  <div class="unseen" style="overflow: auto; min-height: 400px; max-height: 400px">
                    <table class="table table-hover table-bordered">
                      <thead>
                        <tr style="background-color: gainsboro">
                          <th>Date</th>
                          <th>
                            File name<span class="text-danger">&nbsp;*</span>
                          </th>
                          <th class="text-center">
                            Uploaded/Selected file<span class="text-danger">&nbsp;*</span>
                          </th>
                          <th class="text-center">Remark</th>
                          <th class="text-center">
                            Select<span class="text-danger">&nbsp;*</span>
                          </th>
                          <th class="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="
                            let item of itemToEditImage.AtachDoc;
                            let i = index
                          " style="cursor: pointer">
                          <td>
                            <label>{{ item.Date }}</label>
                          </td>
                          <td>
                            <!--File Name-->
                            <label *ngIf="!item.Add">{{ item.FileName }}</label>
                            <div *ngIf="item.Add">
                              <input type="text" class="form-control" name="FileName" id="FileName"
                                [(ngModel)]="item.FileName" [disabled]="item.FileUploadID != 0" />
                            </div>
                          </td>

                          <td>
                            <!--selected -->
                            <label *ngIf="item.FileUploadID == 0">
                              {{ item.UploadedName
                              }}<!-- Uploaded/selected file-->
                            </label>
                            <a *ngIf="item.FileUploadID != 0" [title]="item.UploadedName" class="text-primary" (click)="
                                GetUploadedprint(
                                  item.FileName,
                                  item.FileUploadID,
                                  item.Link
                                )
                              "><u>{{ item.UploadedName }}</u></a>
                            <!--<span *ngIf="item.UploadedName != '' &&  item.FileUploadID == 0" (click)="removeFile(i);"
                              class="fa fa-times-circle fa-3 text-danger" id="UploadedName{{i}}" title="Remove selected file"></span>--><!--Remove selected file-->
                          </td>
                          <td>
                            <!-- Remark-->
                            <label *ngIf="!item.Add">{{ item.Remark }}</label>
                            <div *ngIf="item.Add">
                              <input class="form-control" id="remark{{ i }}" name="remark{{ i }}" type="text"
                                [disabled]="item.FileUploadID != 0" [(ngModel)]="item.Remark" />
                            </div>
                          </td>
                          <td class="text-center">
                            <!--Select-->
                            <input name="file" class="bg-primary" id="upload" type="file"
                              (change)="onFileChange($event)" hidden />
                            <label for="upload" title="Select file">
                              <i [ngClass]="
                                  item.IsFileSelected
                                    ? 'fa fa-paperclip fa-4 mr-2 d-none'
                                    : 'fa fa-paperclip fa-4 mr-2'
                                " (click)="getindex(i)" (dblclick)="getindex(i)" aria-hidden="true"></i>
                            </label>
                          </td>
                          <td class="text-center">
                            <i class="fa fa-plus fa-lg text-success" *ngIf="item.Add" (click)="AddRow(i)"
                              title="Add New"></i>
                            <i class="fa fa-times fa-lg text-danger" *ngIf="
                                (item.FileUploadID != 0 && !item.Add) ||
                                (!item.Add && item.FileUploadID == 0)
                              " title="Delete uploaded file" (click)="
                                DeleteFile(
                                  item.FileUploadID,
                                  item.UploadedName,
                                  item.Link,
                                  i
                                )
                              "></i>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex mt-2">
            <button type="button" id="closed" class="btn btn-md bg-primary mr-2" (click)="(ctad)">
              <i class="fa fa-times mr-1" aria-hidden="true"></i>
              Close
            </button>
            <button type="button" id="saveDocument" class="btn btn-md bg-primary mr-2" [disabled]="isInProgress"
              (click)="UploadFile()" title="Upload File(s)">
              <i [ngClass]="
                  isInProgress
                    ? 'spinner-border spinner-border-sm mr-1'
                    : 'fa fa-save mr-1'
                "></i>
              Upload
            </button>

            <!-- <button type="button" id="OpenCamera" class="btn btn-md bg-primary mr-2" (click)="startCamera()"
            title="Open Camera">
            <i class="fa-solid fa-camera mr-1"></i>
            Open Camera
          </button> -->
          </div>
        </div>
      </form>
    </div>
  </ng-template>

  <!---Patient History Questionnaire List-->
  <div class="container ttm-bgcolor-whiteecolor" style="width: 70%;"
    *ngIf="IsPatientHistorySheet && !globals.IsUserDetailsUpdate">
    <div class="row mt-3 fontsizeandfamilyCalibri">
      <div class="col-auto">
        <button type="button" class="btn btn-square bg-dark" style="color: #ffffff" title="Click to go back" *ngIf="(
          ((!isMainScreen && !isRegistration && !issignin) ||
          isBookingQuetionary ||
          isBookingHistory ||
          globals.isPaymentHistory ||
          isregister ||
          isbooknow) &&
          !isFinalPayment) ||
          IsUserDetailsType == 'click' ||
          (BookingHistory.length > 0 && IsPatientHistorySheet)" (click)="GetBack()">
          <i class="fa fa-lg fa-arrow-left" aria-hidden="true"></i> Back
        </button>
      </div>
      <div class="col-lg">
        <div class="grid-b-space">
          <div class="row">
            <div class="col-md-3 text-right mt-2">
              <label id="lblGuestName">Guest Name</label><!--Guest Name-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{ GuestName }}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 text-right mt-2">
              <label id="lblExpectedcheckin">Date of birth</label>
              <!--Expected check-in-->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{
                GuestQuetionaridetails[0].DateOfBirth | date : "dd-MMM-yyyy"
                }}</strong>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 text-right mt-2">
              <label id="lblNoofdays">Sex</label><!----No. of days---->
            </div>
            <div class="col-md-5 text-left mt-2">
              <strong>{{ GuestQuetionaridetails[0].Gender }}</strong>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg">
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblAccomodation">Address</label><!--Accomodation-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{ GuestQuetionaridetails[0].City }}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label id="lblEmail">E-mail</label><!--E-mail-->
          </div>
          <div class="col-md-5 text-left mt-2">
            <strong>{{ GuestQuetionaridetails[0].Email }}</strong>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 text-right mt-2">
            <label>Select Prefered Language</label>
          </div>
          <div class="col-md-5 text-left mt-2">
            <select class="form-select form-control" id="SelectBank" name="SelectBank"
              [(ngModel)]="QuestionaryLanguageType" (change)="
          GetPatientHistoryQuestionary(SelectedOnlinePatientRegistrationID)
        ">
              <option disabled value="">SELECT LANGUAGE</option>
              <option value="Hindi">Hindi</option>
              <option value="English">English</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive text-left bg-white">
      <div class="unseen">
        <table class="table table-hover table-bordered scroll-table fontsizeandfamilyCalibri">
          <thead>
            <tr class="font-sm fontsizeandfamilyCalibri" style="background-color: #77c5ec">
              <th class="header text-center" style="min-width: 10px !important; max-width: 10px !important">
                Sr No.
              </th>
              <th style="min-width: 100px !important; max-width: 100px !important" class="header">
                Question
              </th>
              <th style="min-width: 100px !important; max-width: 100px !important" class="header">
                Answer
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container class="font-sm" *ngFor="
                let item of itemToEditPatientHistory.QuestionnaireItem;
                let i = index
              ">
              <tr style="background-color: #e3ebdc;">
                <td class="text-center" style="min-width: 10px !important; max-width: 10px !important">
                  {{ i + 1 }}
                </td>
                <td style="
                    min-width: 100px !important;
                    max-width: 100px !important;
                  " (click)="GetQuestionByID(i)" [ngClass]="item.IsMandatory ? 'text-danger' : ''">
                  {{ item.Question }}
                </td>
                <td style="
                    min-width: 100px !important;
                    max-width: 100px !important;
                    background-color: #FFFFFF;
                  " (click)="GetQuestionByID(i)" [class.selected]="selectedindex === i">
                  <ng-container *ngFor="let label of item.SelectedAnswer.split('#')">
                    <button *ngIf="
                        label.trim() !== '' &&
                        item.AnswerType != 3 &&
                        (item.AnswerType == 4 ||
                          item.AnswerType == 5 ||
                          item.AnswerType == 1 ||
                          item.AnswerType == 2)
                      " class="btn btn-sm mb-1 mr-1 font-sm bg-success" [id]="label" [name]="label">
                      {{ label }}
                      <i class="fas fa-times text-danger" (click)="removeAnswer(i, item.Answer, label)"></i>
                    </button>
                  </ng-container>
                  <input type="text" class="form-control" name="TextAnswer" autocomplete="off"
                    [(ngModel)]="item.TextAnswer" (keypress)="
                      item.Validation == 1
                        ? validateService.numberAnddotonlyAndalphabetOnly(
                            $event
                          )
                        : item.Validation == 2
                        ? validateService.numberAnddotonly($event)
                        : ''
                    " *ngIf="
                      (item.AnswerType == 3 ||
                        item.AnswerType == 4 ||
                        item.AnswerType == 5) &&
                      item.Validation != 3
                    " />

                  <div class="input-group" *ngIf="
                      item.Validation == 3 &&
                      (item.AnswerType == 3 ||
                        item.AnswerType == 4 ||
                        item.AnswerType == 5)
                    ">
                    <input class="form-control" type="datetime" id="SelectedDate" name="SelectedDate"
                      [matDatepicker]="Received" [(ngModel)]="item.SelectedDate" disabled />
                    <span class="input-group-append">
                      <mat-datepicker-toggle matSuffix [for]="Received"></mat-datepicker-toggle>
                      <mat-datepicker #Received [disabled]="false"></mat-datepicker>
                    </span>
                  </div>
                </td>
              </tr>
              <tr *ngIf="selectedindex == i && item.Answer != ''" style="background-color: #b9d9f6"
                (contextmenu)="selectedindex = -1; $event.preventDefault()">
                <td colspan="3">
                  <span id="{{ i }}" (contextmenu)="selectedindex = -1; $event.preventDefault()">
                    <ng-container *ngFor="let label1 of item.Answer.split('#')">
                      <button type="button" class="btn btn-sm mb-1 mr-1 font-sm bg-success" *ngIf="label1.trim() !== ''"
                        (click)="
                          SetAnswerData(
                            i,
                            label1,
                            item.AnswerType,
                            item.Validation
                          )
                        ">
                        {{ label1 }}
                      </button>
                    </ng-container>
                  </span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-3 d-flex justify-content-center fontsizeandfamilyCalibri">
      <button type="button" name="submitButton" id="submitButton" class="btn btn-li btn-square text-white"
        (click)="SaveCasepaperQuestionnaire()" [disabled]="isInProgress">
        <i class="fa fa-save mr-1"></i> Submit
      </button>
    </div>
  </div>

  <!-- cancelation Booking-->
  <ng-template #contentCancellation let-cab="close('b')">
    <div class="bg-white rounded container-fluid fontsizeandfamilyCalibri">
      <div style="
          max-width: 500px;
          margin: auto;
          background: white;
          padding: 24px;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          font-family: Arial, sans-serif;
        ">
        <!-- Cancellation Reason -->
        <div style="margin-bottom: 16px">
          <label for="cancelReason" style="display: block; font-weight: 600; margin-bottom: 6px">Cancellation
            Reason</label>
          <select id="cancelReason" [(ngModel)]="CancellationReason" style="
              width: 100%;
              padding: 8px;
              border: 1px solid #ccc;
              border-radius: 4px;
            ">
            <option disable value="">Select a reason</option>
            <option *ngFor="let cc of CancellationReasonList" [value]="cc.Description">
              {{ cc.Description }}
            </option>
          </select>
        </div>

        <!-- Action on Balance -->
        <div class="d-none" style="margin-bottom: 16px">
          <label style="display: block; font-weight: 600; margin-bottom: 6px">Action on Balance</label>
          <label style="margin-right: 20px">
            <input type="radio" name="balanceAction" [(ngModel)]="ActiononBalance" value="refund" />
            Refund the Balance
          </label>
          <label>
            <input type="radio" name="balanceAction" [(ngModel)]="ActiononBalance" value="keep" />
            Keep the Balance
          </label>
        </div>

        <!-- Deduction Amount -->
        <div style="margin-bottom: 20px">
          <label for="deductionAmount" style="display: block; font-weight: 600; margin-bottom: 6px">Deduction
            Amount</label>
          <input type="number" disabled id="deductionAmount" placeholder="Enter deduction amount"
            [(ngModel)]="DeductedAmount" style="
              width: 100%;
              padding: 8px;
              border: 1px solid #ccc;
              border-radius: 4px;
            " />
        </div>

        <!-- Submit Button -->
        <div style="text-align: left">
          <button type="submit" id="DeactivateBookingID" (click)="(cab)" style="
              background-color: #007bff;
              color: white;
              padding: 8px 16px;
              border: none;
              border-radius: 4px;
              cursor: pointer;
            ">
            Close
          </button>
          <button type="submit" (click)="DeactivateBookingID('', 0, 0, '', 0, '','')" class="ml-2"
            [disabled]="IsDeactivateClick" style="
              background-color: #007bff;
              color: white;
              padding: 8px 16px;
              border: none;
              border-radius: 4px;
              cursor: pointer;
            ">
            <i [ngClass]="IsDeactivateClick ? 'spinner-border spinner-border-sm mr-1' : ''"></i>
            Submit
          </button>
        </div>
      </div>
    </div>
  </ng-template>



  <ng-template #contentCancellationPolicy let-cab="close('b')">
    <div class="container-fluid fontsizeandfamilyCalibri" style="background: #ffffff; border-radius: 12px; padding: 20px;
              font-family: Calibri, sans-serif; color: #333;">

      <div style="padding: 10px 0;">

        <div style="font-size: 20px; font-weight: 700;
                  text-align: left; color: #d9534f; display: flex; align-items: center;">
          ⚠️ <span style="margin-left: 8px;">Cancellation Policy</span>
        </div>

        <div style="margin-top: 12px; font-size: 16px; line-height: 1.6; text-align: left;">
          • <strong>0% deduction</strong> if cancelled
          <strong>15 days or more</strong> before check-in.<br>
          • <strong>50% deduction</strong> if cancelled
          <strong>7 to 14 days</strong> before check-in.<br>
          • <strong>75% deduction</strong> if cancelled
          <strong>3 to 6 days</strong> before check-in.<br>
          • <strong>90% deduction</strong> if cancelled
          <strong>1 to 2 days</strong> before check-in.<br>
          • <strong>100% deduction</strong> on the <strong>day of check-in</strong>.
        </div>

        <!-- Submit Button -->
        <div style="text-align: right; margin-top: 20px;">
          <button type="submit" id="DeactivateBookingID" (click)="cab; GetRazorpay();" style="background: #d9534f; border: none; color: white;
                       padding: 10px 24px; font-size: 16px; font-weight: 600;
                       border-radius: 6px; cursor: pointer; transition: 0.3s;">
            Close
          </button>
        </div>

      </div>

    </div>
  </ng-template>

</div>
<div *ngIf="section == 'UserDetails'">
  <div *ngIf="globals.IsUserDetailsUpdate">
    <div class="container mt-2">
      <form #f="ngForm" novalidate>
        <h1 class="text-left">Edit User Details</h1>
        <!-- <div class="row">
        <div class="col-lg-4">
          <div class="form-group text-left">
            <strong id="lblFirstName"
              >First Name <span style="color: red">*</span></strong
            >
            <input
              type="text"
              name="FirstName"
              id="FirstName"
              class="form-control"
              (input)="
                UpperCase(OnlineUserRegistration.FirstName, 'FirstName');
                TrimName(OnlineUserRegistration.FirstName, 'FirstName')
              "
              [(ngModel)]="OnlineUserRegistration.FirstName"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group text-left">
            <strong id="lblMiddleName">Middle Name </strong>
            <input
              class="form-control"
              type="text"
              placeholder="Middle Name"
              name="middleName"
              (input)="
                UpperCase(OnlineUserRegistration.MiddleName, 'MiddleName');
                TrimName(OnlineUserRegistration.MiddleName, 'MiddleName')
              "
              [(ngModel)]="OnlineUserRegistration.MiddleName"
            />
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group text-left">
            <strong id="lblLastName"
              >Last Name <span style="color: red">*</span></strong
            >
            <input
              class="form-control"
              type="text"
              placeholder="Last Name"
              name="lastName"
              (input)="
                UpperCase(OnlineUserRegistration.LastName, 'LastName');
                TrimName(OnlineUserRegistration.LastName, 'LastName')
              "
              [(ngModel)]="OnlineUserRegistration.LastName"
              required
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group text-left">
            <strong id="lblUserName"
              >User Name <span style="color: red">*</span></strong
            >
            <input
              class="form-control"
              type="text"
              placeholder="User Name"
              name="UserName"
              minlength="4"
              [(ngModel)]="OnlineUserRegistration.UserID"
              (keypress)="
                validateService.validateOnlyNumberAndAlphabets($event)
              "
              required
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group text-left">
            <strong id="lblMobileNo"
              >Mobile No<span style="color: red">*</span></strong
            >
            <input
              class="form-control"
              type="text"
              placeholder="Mobile Number"
              name="mobileNo"
              [(ngModel)]="OnlineUserRegistration.MobileNo"
              pattern="[0-9]{10}"
              (keypress)="validateService.numberOnly($event)"
              maxlength="10"
              required
              autocomplete="off"
            />
            <div class="input-group-append">
              <span
                class="input-group-text password-toggle"
                (click)="GetGSMasWAGSM(isWAGSM, 'User')"
              >
                <i
                  class="fa fa-whatsapp"
                  style="color: green"
                  title="WhatsApp Connected?"
                ></i>
              </span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group text-left">
            <strong id="lblWMobileNo">WhatsApp Mobile Number</strong>
            <input
              type="text"
              name="WAGSMR"
              id="WAGSMR"
              class="form-control"
              placeholder="WhatsApp Mobile Number"
              (keypress)="validateService.numberOnly($event)"
              maxlength="10"
              [(ngModel)]="OnlineUserRegistration.WhatsAppNo"
              required
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group text-left">
            <strong id="lblCity">City</strong>
            <input
              type="text"
              name="CityR"
              id="CityR"
              class="form-control"
              [(ngModel)]="OnlineUserRegistration.City"
              placeholder="City"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group text-left">
            <strong id="lblState">State</strong>
            <input
              type="text"
              name="StateR"
              id="StateR"
              class="form-control"
              [(ngModel)]="OnlineUserRegistration.State"
              placeholder="State"
            />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group text-left">
            <strong id="lblCountry"
              >Country<span style="color: red">*</span></strong
            >
            <input
              type="text"
              name="CountryR"
              id="CountryR"
              class="form-control"
              [(ngModel)]="OnlineUserRegistration.Country"
              placeholder="Country"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group text-left">
            <strong id="lblEmail"
              >Email<span style="color: red">*</span></strong
            >
            <input
              type="text"
              class="form-control"
              placeholder="Email Address"
              name="email"
              [(ngModel)]="OnlineUserRegistration.Email"
              (input)="validateEmail(OnlineUserRegistration.Email)"
              required
              email
            /><br />
          </div>
        </div>
        <div class="col-md-4">
          <div
            class="form-group text-left"
            *ngIf="IsOTPSent == true && IsEmailVerified == false"
          >
            <strong id="lblOTP">OTP</strong>
            <input
              type="text"
              name="otp"
              class="form-control"
              placeholder="OTP"
              [(ngModel)]="OTP"
              (keypress)="validateService.numberOnly($event)"
              maxlength="4"
              required
            /><br />
          </div>
          <div class="form-group text-left" *ngIf="IsEmailVerified == true">
            <strong id="lblPassword">Password</strong>
            <div class="d-flex align-items-center">
              <input
                type="password"
                name="Password"
                class="form-control"
                placeholder="Password"
                [(ngModel)]="OnlineUserRegistration.Password"
                required
              /><br />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <button
            type="button"
            [disabled]="OnlineUserRegistration.Email == '' || !this.UpdateEmail"
            *ngIf="IsOTPSent == false && IsEmailVerified == false"
            class="btn btn-primary btn-block btn-lg btn-square"
            (click)="VerifyUserEmail('Update')"
          >
            <i
              [ngClass]="
                isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''
              "
            ></i>
            Verfiy Email
          </button>
          <button
            type="button"
            *ngIf="IsOTPSent == true"
            (click)="VerifyOTP(OnlineUserRegistration.Email, OTP, 'Update')"
            class="btn btn-primary btn-block btn-lg btn-square"
          >
            <i
              [ngClass]="
                isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''
              "
            ></i>
            Verfiy with OTP
          </button>
          <div class="form-group text-left" *ngIf="IsEmailVerified == true">
            <strong id="lblPassword">Confirm Password</strong>
            <div class="d-flex align-items-center">
              <input
                type="password"
                name="ConfirmPassword"
                class="form-control"
                placeholder="Confirm Password"
                [(ngModel)]="OnlineUserRegistration.ConfirmPassword"
                required
              /><br />
            </div>
          </div>
        </div>
      </div> -->

        <div class="row">
          <div class="col-md-4">
            <div class="form-group text-left">
              <strong id="lblFirstName">First Name <span style="color: red">*</span></strong>
              <!--First Name-->
              <input class="form-control" type="text" placeholder="First Name" (input)="
                  UpperCase(OnlineUserRegistration.FirstName, 'FirstName');
                  TrimName(OnlineUserRegistration.FirstName, 'FirstName')
                " name="FirstName" [(ngModel)]="OnlineUserRegistration.FirstName" required />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group text-left">
              <strong id="lblMiddleName">Middle Name </strong>
              <!--Middle Name-->
              <input class="form-control" type="text" placeholder="Middle Name" (input)="
                  UpperCase(OnlineUserRegistration.MiddleName, 'MiddleName');
                  TrimName(OnlineUserRegistration.MiddleName, 'MiddleName')
                " name="middleName" [(ngModel)]="OnlineUserRegistration.MiddleName" />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group text-left">
              <strong id="lblLastName">Last Name <span style="color: red">*</span></strong>
              <!--Last Name-->
              <input class="form-control" type="text" placeholder="Last Name" (input)="
                  UpperCase(OnlineUserRegistration.LastName, 'LastName');
                  TrimName(OnlineUserRegistration.LastName, 'LastName')
                " name="lastName" [(ngModel)]="OnlineUserRegistration.LastName" required />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <!-- User Name -->
            <div class="form-group text-left">
              <strong id="lblUserName">User Name <span style="color: red">*</span></strong>
              <div class="d-flex align-items-center">
                <input class="form-control" type="text" placeholder="User Name" name="UserName"
                  [(ngModel)]="OnlineUserRegistration.UserID" #UserName="ngModel" minlength="3" required
                  (input)="validateUsername(OnlineUserRegistration.UserID)"
                  (keypress)="validateService.validateUserName($event)" />

                <!-- Info Icon -->
                <span class="info-icon ms-2"><i class="fa-solid fa-circle-info"></i>
                  <div class="tooltip-box">
                    <ul class="validation-rules">
                      <li [class.valid]="usernameRules.length">
                        3–20 characters
                      </li>
                      <li [class.valid]="usernameRules.startWithLetter">
                        Starts with a letter
                      </li>
                      <li [class.valid]="usernameRules.allowedChars">
                        Only letters, numbers, underscore (_) or dot (.)
                      </li>
                    </ul>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group text-left">
              <strong id="lblMobileNo">Mobile No<span style="color: red">*</span></strong>
              <div class="input-group">
                <!--mobile No-->
                <input class="form-control" type="text" placeholder="Mobile Number" name="mobileNo"
                  [(ngModel)]="OnlineUserRegistration.MobileNo" pattern="[0-9]{10}"
                  (keypress)="validateService.numberOnly($event)" maxlength="10" required autocomplete="off" />
                <div class="input-group-append">
                  <!--Whatsapp connected-->
                  <span class="input-group-text password-toggle" (click)="GetGSMasWAGSM(isWAGSM, 'User')">
                    <i class="fa fa-whatsapp" style="color: green" title="WhatsApp Connected?"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <!--WhatsApp Mobile Number-->
            <div class="form-group text-left">
              <strong id="lblWMobileNo">WhatsApp Mobile Number</strong>
              <input type="text" name="WAGSMR" id="WAGSMR" class="form-control" placeholder="WhatsApp Mobile Number"
                (keypress)="validateService.numberOnly($event)" maxlength="10"
                [(ngModel)]="OnlineUserRegistration.WhatsAppNo" required />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <!--Country-->
            <div class="form-group text-left">
              <strong id="lblCountry">Country<span style="color: red">*</span></strong>
              <div class="d-flex align-items-center">
                <input type="text" name="CountryR" id="CountryR" class="form-control"
                  [(ngModel)]="OnlineUserRegistration.Country" placeholder="Country" [matAutocomplete]="autoC" />
                <mat-autocomplete #autoC="matAutocomplete">
                  <mat-option *ngFor="
                      let City of CountryandNationality
                        | filter : OnlineUserRegistration.Country
                    " [value]="City['Country']" title="{{ City['Country'] }}">
                    {{ City["Country"] }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <!--State-->
            <div class="form-group text-left">
              <strong id="lblWState">State</strong>
              <div class="d-flex align-items-center">
                <input type="text" name="StateR" id="StateR" class="form-control"
                  [(ngModel)]="OnlineUserRegistration.State" placeholder="State" [matAutocomplete]="autoState" />
                <mat-autocomplete #autoState="matAutocomplete">
                  <mat-option *ngFor="
                      let state of States
                        | filter : OnlineUserRegistration.State;
                      trackBy: trackByFn
                    " (onSelectionChange)="
                      GetDistrictList($event); GetCityList($event, 'User')
                    " [value]="state['State']" title="{{ state['State'] }}">
                    {{ state["State"] }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group text-left">
              <!----- District ------>
              <strong id="lblWDistrict">District</strong>
              <input type="text" name="District" id="District" class="form-control" [matAutocomplete]="autoDistrict1"
                [(ngModel)]="OnlineUserRegistration.District" placeholder="District" />
            </div>
            <mat-autocomplete #autoDistrict1="matAutocomplete">
              <mat-option *ngFor="
                  let cc of District | filter : OnlineUserRegistration.District;
                  trackBy: trackByFn
                " (onSelectionChange)="GetCityList($event, 'User')" [value]="cc['District']"
                title="{{ cc['District'] }}">
                {{ cc["District"] }}
              </mat-option>
            </mat-autocomplete>
          </div>

          <div class="col-md-4">
            <!--City-->
            <div class="form-group text-left">
              <strong id="lblWCity">City</strong>
              <div class="d-flex align-items-center">
                <input type="text" name="CityR" id="CityR" class="form-control"
                  [(ngModel)]="OnlineUserRegistration.City" placeholder="City" [matAutocomplete]="autoCity" />
                <mat-autocomplete #autoCity="matAutocomplete">
                  <mat-option *ngFor="
                      let aa of City | filter : OnlineUserRegistration.City;
                      trackBy: trackByFn
                    " [value]="aa['City']" title="{{ aa['City'] }}">
                    {{ aa["City"] }}
                  </mat-option>
                </mat-autocomplete>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group text-left">
              <!--Email-->
              <strong id="lblEmail">Email<span style="color: red">*</span></strong>
              <div class="d-flex align-items-center">
                <!--Email-->
                <input type="text" class="form-control" placeholder="Email Address" name="email"
                  [(ngModel)]="OnlineUserRegistration.Email" [disabled]="IsEmailVerified"
                  (input)="validateEmail(OnlineUserRegistration.Email)" required email />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <div class="form-group text-left" *ngIf="IsEmailVerified == false">
              <!--OTP-->
              <strong id="lblOTP">OTP</strong>
              <div class="d-flex align-items-center">
                <input type="text" name="otp" class="form-control" placeholder="OTP" [(ngModel)]="OTP"
                  (keypress)="validateService.numberOnly($event)" maxlength="4" [disabled]="IsOTPSent == false"
                  required />
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <button type="button" [disabled]="
                OnlineUserRegistration.Email == '' || !this.UpdateEmail
              " *ngIf="IsOTPSent == false && IsEmailVerified == false"
              class="btn btn-primary btn-block btn-lg btn-square" (click)="VerifyUserEmail('Update')">
              <i [ngClass]="
                  isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''
                "></i>
              Verfiy Email
            </button>
            <button type="button" *ngIf="IsOTPSent == true"
              (click)="VerifyOTP(OnlineUserRegistration.Email, OTP, 'Update')"
              class="btn btn-primary btn-block btn-lg btn-square">
              <i [ngClass]="
                  isInProgress ? 'spinner-border spinner-border-sm mr-1' : ''
                "></i>
              Verfiy with OTP
            </button>
          </div>
          <div class="col-md-4">
            <button type="button" (click)="SaveUserDetails()" [disabled]="!f.valid || !IsEmailVerified"
              class="btn btn-primary btn-block btn-lg btn-square">
              <i [ngClass]="
                  isInProgressRegister
                    ? 'spinner-border spinner-border-sm mr-1'
                    : ''
                "></i>
              Save</button><!--Register-->
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- <div class="row d-flex justify-content-center align-items-center mt-2 mb-2">
  <button type="button" class="btn btn-circle btn-secondary" title="Click to go back" *ngIf="
      (((!isMainScreen && !isRegistration && !issignin) ||
        isBookingQuetionary ||
        isBookingHistory ||
        isPaymentHistory ||
        isBookingQuetionary ||
        isregister ||
        isbooknow) &&
        !isFinalPayment) ||
      IsUserDetailsType == 'click' ||
      (this.BookingHistory.length > 0 && IsPatientHistorySheet)
    " (click)="GetBack()"> -->
<!-- <i class="fa fa-lg fa-arrow-left" aria-hidden="true"></i> -->
<!-- Back
  </button>
</div> -->